var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.productZoomSlider = document.querySelector('product-zoom');
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 150);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
    this.productZoomSlider.hide();
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      index = this.slideshow.swiperElement.realIndex;
      index = this.slideshow.swiperElement.slides[index]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.productZoomSlider.show(index);

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map((image) => {
      const screenWidth = window.innerWidth; // Get the screen width dynamically

      let maxWidth = parseInt(image.getAttribute("data-max-width"));
      let maxHeight = parseInt(image.getAttribute("data-max-height"));

      if (responsive.matchesBreakpoint("lap_and_up") && maxWidth > screenWidth) {
        const aspectRatio = maxHeight / maxWidth; // Maintain aspect ratio
        maxWidth = screenWidth;
        maxHeight = Math.round(maxWidth * aspectRatio); // Adjust height accordingly
      }

      const maxDimension = responsive.matchesBreakpoint("phone") ? 1200 : 2200;

      const reduceFactor =
        maxWidth >= maxHeight
          ? Math.max(maxWidth / maxDimension, 1.0)
          : Math.max(maxHeight / maxDimension, 1.0);

      return {
        msrc: image.currentSrc || image.src,
        w: Math.floor(maxWidth / reduceFactor),
        h: Math.floor(maxHeight / reduceFactor),
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }


  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: true,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.delegateRoot.on("slide:change", (e) => {
      this.photoSwipeInstance.goTo(e.detail)
    });

    this.photoSwipeInstance.listen('afterChange', () => {
      this.productZoomSlider.setActiveSlide(this.photoSwipeInstance.getCurrentIndex());
    });

    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );

    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );


    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");


    var innerContent = event.target.innerText;

    var selEl = this.element.querySelector("#" + selectboxID);

    if (this.mainButton.classList.contains('subs-selectbox')) {
      var cutContent = innerContent.substring(0, 8) + '...';
      this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
        cutContent;
    } else {

      this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
        innerContent;
    }
    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }

    if (event.target.getAttribute('data-plan-id')) {

      const planId = event.target.getAttribute('data-plan-id');
      const price = event.target.getAttribute('data-price-raw');
      let subPrice;
      if (price) {
        subPrice = Shopify.formatMoney(
          price,
          window.theme.moneyFormat
        )
      }
      this.element.dispatchEvent(
        new CustomEvent("sticky-subs:change", {
          bubbles: true,
          detail: {
            eventName: "stickSub",
            planId: planId,
            subPrice: subPrice
          },
        })
      );
    }
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));

    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");


    }


    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element, event);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.


    let delay = 0;
    if (
      (this.element.classList.contains("RevolutionSelectbox--Selectors") &&
        responsive.matchesBreakpoint("lap_and_up")) ||
      this.popover
    ) {
      this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
      );

      if (!this.popover) {
        this.element.dispatchEvent(
          new CustomEvent("menu:close", { bubbles: true })
        );
      }

      setTimeout(() => {
        this.header = document.querySelector(".header");
        if (this.header) {
          this.header.showOrHide();
        }

        const focus = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");
        if (target.closest('.RevolutionSelectbox--Selectors')) {
          this.element.dispatchEvent(
            new CustomEvent("selectbox:open", { bubbles: true })
          );
        }
      }, 10);

      delay = 300;
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      if (item != this.element) {
        item
          .querySelector(".RevolutionSelectbox--Button")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          item
            .querySelector(".RevolutionSelectbox--Content")
            .setAttribute("aria-hidden", true);
          item.querySelector(".RevolutionSelectbox--Content").style.display =
            "none";
        }, delay);
      }
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      setTimeout(() => {
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener(
          "click",
          this.onClickOutsideListener
        );
        const focus = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");
        trapFocus(this.mainDropdown);
      }, 10);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target, event) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (
      this.element.classList.contains("RevolutionSelectbox--Selectors") &&
      responsive.matchesBreakpoint("lap_and_up") && this.mainDropdown.getAttribute("aria-hidden") === "false"
    ) {
      if (this.header && document.querySelector('search-bar[aria-hidden="true"]')) {
        if (event && event.type != 'menu:open') {
          this.header.toggleColor();
        } else if (!event) {
          this.header.toggleColor(true);
        }
      }
      bodyScrollLock.clearAllBodyScrollLocks();
      document.body.classList.remove("scrollLock");
    }
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  addToCart(event, target) {
    var _this = this;
    event.preventDefault();
    if (target.closest('[data-action="add-to-cart"]').hasAttribute("disabled"))
      return;
    var addToCartButton = event.target;
    let isCartItemGift;
    if (addToCartButton.getAttribute("data-is-gift")) {
      isCartItemGift = true;
    } else {
      isCartItemGift = false;
    }

    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");

    var formElement = event.target.closest("form");
    if (!formElement) {
      formElement = document.querySelector(
        `#${event.target.getAttribute("for")}`
      );
    }
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.location.href.indexOf("cart") != -1) {
          const checkIfGift = isCartItemGift;
          const giftContainer = _this.element.querySelector(".gift-container");
          if (checkIfGift && giftContainer) {
            const items = giftContainer.querySelectorAll(".cart-item");
            if (items) {
              items.forEach(item => {
                const remove = item.querySelector("[data-action='remove-item']");
                if (remove) {
                  remove.click()
                }
              });
            }
          } else {
            location.reload();
          }
          return;
        }

        addToCartButton.removeAttribute("disabled");
        const isGift = isCartItemGift;
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              isGift: isGift,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
            addToCartButton.removeAttribute("disabled");
          } else {
            var errorMessageElement = document.querySelector(".product-error");
            if (errorMessageElement.innerHTML.trim() !== '') return;
            errorMessageElement.innerHTML = content["description"];
            errorMessageElement.setAttribute("aria-hidden", "false");
            addToCartButton.removeAttribute("disabled");
            setTimeout(function () {
              errorMessageElement.setAttribute("aria-hidden", "true");
              setTimeout(function () {
                errorMessageElement.innerHTML = "";
              }, 300);
            }, 2500);
          }
        });
      }
    });
  }

  async getCartItemNumber() {
    const response = await fetch(`${window.routes.localeRootUrl}/cart.js`, {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      const errorContent = await response.json();
      throw errorContent;
    }

    return response;
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();
class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + "px";
    if (
      this.element.getAttribute("id") == "cart-drawer" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".cart-drawer__footer");
      var footerHeight = 0;
      if (footer && footer.offsetHeight > 0) {
        footerHeight = footer.offsetHeight;
        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          `${footerHeight}px`
        );
      }

      const headerEl = this.element.querySelector(".cart-drawer__header");
      let header = 0;
      if (headerEl) {
        header = headerEl.offsetHeight;
        document.documentElement.style.setProperty(
          "--cart-drawer__header-height",
          `${header}px`
        );
      }
    } else {
      const content = this.element.querySelector(".Drawer--Content");
      const header =
        this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      const footer =
        this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;

      if (content) {
        let maxHeight = window.innerHeight;
        if (this.element.id === 'mobile-menu') {
          maxHeight = this.element.offsetHeight;
        }
        const contentHeight = maxHeight - header - footer;
        content.style.height = contentHeight + "px";

        const loader = this.element.querySelector(".spinningLoader");
        if (loader) {
          loader.style.height = contentHeight + 32 + "px";
          loader.style.top = header - 16 + "px";
        }
      }
    }
  }

  toggleDrawer(e) {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer(e);
  }

  openDrawer(e) {

    if (this.element.getAttribute("id") == "size-guide-collection-page") {
      this.pageOverlayElement.classList.add("subdrawer");
    }
    if (this.element.getAttribute("id") != "size-guide-collection-page") {
      this.element.dispatchEvent(
        new CustomEvent("drawer:close-other", { bubbles: true })
      );
    }

    if (this.element.classList.contains("MobileMenu--wrapper")) {
      this.hamburger.classList.add("is-active");
    }

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    if (this.isOpen) {
      return;
    }

    if (this.element.id !== "mobile-menu") {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }

    if (this.element.getAttribute("id") == "Drawer") {
      document.querySelector(".Drawer--Close").style.display = "block";
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    }

    this.element.setAttribute("aria-hidden", "false");
    this.maxHeight();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", "true");
        var focus = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");
      });
    });

    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen(e);
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "Drawer") {
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    }

    if (this.element.id !== "mobile-menu") {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }

    this.element.setAttribute("aria-expanded", "false");
    const transitionEndHandler = (event) => {
      if (this.element.id === 'mobile-menu' && event.propertyName === "opacity") {
        this.element.setAttribute("aria-hidden", "true");
      }

      if (this.element.id === 'cart-drawer') {
        this.element.removeAttribute("aria-hidden");
      }

      this.element.removeEventListener(
        "transitionend",
        transitionEndHandler
      );
    };
    if (this.element.id === 'mobile-menu' || this.element.id === 'cart-drawer') {
      this.element.addEventListener("transitionend", transitionEndHandler);
    } else {
      this.element.setAttribute("aria-hidden", "true");
    }


    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);

        return false;
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: 1750,
          easing: "ease",
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    const calculateThreshold = (element) => {
      const elementHeight = element.offsetHeight;
      // If the element is taller than 500px, calculate a pixel-based threshold
      if (elementHeight > 500) {
        const pixelThreshold = 100;
        let threshold = pixelThreshold / elementHeight;

        // Fallback to 0.15 if the calculated threshold is 0 or invalid
        if (threshold <= 0) {
          threshold = 0.15;
        }
        return threshold;
      }

      // Default threshold for smaller elements
      return 0.15;
    };

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
          elementFadeIn: "elementFadeIn",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: calculateThreshold(animatedItem) }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }

  calculateThreshold(pixelThreshold) {
    const target = document.querySelector(options.target); // Use the correct selector
    if (!target) {
      console.warn("Target element not found for threshold calculation.");
      return 0.15; // Fallback to default threshold
    }

    const elementHeight = target.offsetHeight;

    // Calculate the threshold based on pixelThreshold
    let threshold = pixelThreshold / elementHeight;

    // Fallback to 0.15 if the threshold is 0 or invalid
    if (threshold <= 0) {
      threshold = 0.15;
    }

    return threshold;
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".product-module__product-atc"),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value;
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.forEach((button) => button.removeAttribute("disabled"));
    addButton.forEach((button) =>
      button.classList.remove("product-module__product-atc--sold-out")
    );
    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='product-module__atc-price u-pb1'>| " +
        Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      +"</span>";
    } else {
      var priceElement = "";
    }

    addButton.forEach((button) => {
      button.querySelector(
        ".product-module__product-atc .ButtonText"
      ).innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;
    });
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
      ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
      "{countdown}",
      '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
      .split(":")
      .map(Number);
    if (
      targetHours < currentHours ||
      (targetHours === currentHours &&
        targetMinutes <= currentMinutes &&
        this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.cartCount = document.querySelector(".cart-count");
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
      },
      onOpen: () => {

        this.isOpen = true;
        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".itemLoader");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.recommendationsLoaded = false;
    this.alreadyEntered = false;
    new AddToCart(this.element);

    this.bindEvents();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);

      if (this.options["showRecommendations"]) {
        window.addEventListener("load", () => this.loadRecommendations());
      }

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  onOpen() {
    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      document.querySelector(".cart-drawer__header").offsetHeight + "px"
    );
    const currentShippingBar = this.element.querySelector(
      ".cart-drawer__shipping-progress-bar"
    );

    const giftContainer = this.element.querySelector(".cart__gift-wrapper");
    if (giftContainer) {
      if (currentShippingBar) {
        const gift = currentShippingBar.getAttribute("data-include-gift");
        let percent = currentShippingBar.dataset.percent;
        if (percent > 100) {
          percent = 100;
        }

        if (percent == 100 && gift == "true") {
          giftContainer.setAttribute("aria-hidden", "false");
        } else {
          giftContainer.setAttribute("aria-hidden", "true");
        }

      }
    }

    if (this.options["showRecommendations"]) {
      this.loadRecommendations();
    }

  }

  onClose() {
    if (this.aboutToOpenRecommendaions) {
      clearTimeout(this.aboutToOpenRecommendaions);
    }
  }

  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async updateItemQuantity(event, target) {
    if (event) {
      event.preventDefault();
    }

    if (this.isUpdatingItem) return;
    this.isUpdatingItem = true;

    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }

      const currentQuantityInput = cartItem.querySelector(".cart-item__quantity");
      const itemQuantity = currentQuantityInput ? parseInt(currentQuantityInput.value, 10) || 1 : 1;
      const currentCount = window.theme.cartCount || parseInt(this.cartCount.innerHTML) || 0;
      const newCount = Math.max(0, currentCount - itemQuantity);
      this.cartCount.innerHTML = `${newCount}`;
      window.theme.cartCount = newCount;

      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0 && data.item_count > 0) {
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
        }
        this.renderCart(false, false, false, null, true);
        return;
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
    } finally {
      this.isUpdatingItem = false;
    }
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute("data-open-drawer")) {
        if (this.isOpen == false) {
          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }
    });
  }

  renderCart(
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    this.pageLoader.style.width = 100 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer&_=" + Date.now(),
      {
        credentials: "same-origin",
        method: "GET",
        cache: "no-store",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );
        if (_this.options.showRecommendations) {
          _this.loadRecommendations();
        }
      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {
    if (!updateCount) {
      // Prepare the page loader animation
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    const oldOptions = this.options;
    this.options = newOptions;

    if (!updateCount) {
      if (tempElement.querySelector("[data-ids]") != undefined) {
        this.cartIds = tempElement
          .querySelector("[data-ids]")
          .dataset.ids.split(",")
          .filter((item) => item !== "");
      }
    }

    let itemCount = parseInt(newOptions.itemCount) === 0 ? '' : newOptions.itemCount;
    this.cartCount.innerHTML = `${itemCount}`;
    window.theme.cartCount = parseInt(itemCount);

    let oldOptionsInfoCount = parseInt(oldOptions.itemCount) === 0 ? '' : oldOptions.itemCount;

    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }
    if (lineNumber) {
      this.updateCartFooter(tempElement);
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && oldOptionsInfoCount > 0) {
      this.updateCartFooter(tempElement);
      this.addContent(tempElement, productAddEvent);
    } else {
      // replaceCartContent replaces the entire wrapper including footer — skip updateCartFooter
      // to avoid mutating tempElement before it's consumed
      this.replaceCartContent(tempElement);
    }

    // Additional actions after a brief delay
    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }
      const focusElement = this.element.querySelector("[data-scrollable]");
      if (this.element.hasAttribute("data-open-drawer")) {
        bodyScrollLock.disableBodyScroll(focusElement, bodyScrollLockOptions);
      }
      this.drawer.maxHeight();
    }, 200);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info`
    );

    if (!cartItemParent) {
      this.element.querySelector(".itemLoader").classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.replaceChild(
        newCartItemInfo,
        cartItemParent.querySelector(".cart-item__info")
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    const giftCollection = this.element.querySelector(".cart__gift-wrapper");
    const giftCollectionItems = giftCollection ? giftCollection.querySelectorAll('[data-variant-id]') : null;

    if (this.isOpen && !productAddEvent.isGift) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }

    let containerToAdd;
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const itemToAdd = tempElement.querySelector(`#cart-item__${productAddEvent.variant}`);

    if (productAddEvent.isGift) {
      // Create container for gifts if it doesn't exist
      containerToAdd = this.element.querySelector(".gift-container");

      if (!containerToAdd) {
        containerToAdd = document.createElement("div");
        containerToAdd.classList.add("gift-container");
        cartWrapper.appendChild(containerToAdd);
      }

      // Check if a gift already exists in the container
      const existingGift = containerToAdd.querySelector(".cart-item");


      if (existingGift) {
        if (existingGift.dataset.variantId === productAddEvent.variant || existingGift.size == 1) {
          return;
        } else {
          const removeButton = existingGift.querySelector('[data-action="remove-item"]');
          if (removeButton) {
            removeButton.click();
            giftCollectionItems?.forEach(item => {
              if (item.dataset.variantId === existingGift.dataset.variantId) {
                const parentLi = item.closest('li');
                if (parentLi) {
                  parentLi.style.display = 'block';
                }
              }
            });
          }

        }
      }
    }

    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      if (!productAddEvent.isGift) {
        this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
      }
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );

      this.loader.classList.remove("is-visible");

      if (productAddEvent.isGift) {
        // Append the gift item to the gift container
        setTimeout(() => {
          containerToAdd.appendChild(itemToAdd);

          itemToAdd.classList.add("repo--adding");

          giftCollectionItems.forEach(item => {
            if (item.dataset.variantId === productAddEvent.variant) {
              const parentLi = item.closest('li');
              if (parentLi) {
                parentLi.style.display = 'none';
              }
            }
          });

          setTimeout(() => {
            itemToAdd.classList.remove("repo--adding");
          }, 350);
        }, 350);
      } else {
        // Prepend regular product item to the top of the cart  
        setTimeout(() => {
          cartWrapper.prepend(itemToAdd);
          itemToAdd.classList.add("repo--adding");

          setTimeout(() => {
            itemToAdd.classList.remove("repo--adding");
          }, 350);
        }, 350);
      }
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {
      const footerParent = this.element.querySelector(".cart-drawer__footer");
      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      if (!footerParent || !newFooterTotals) return;
      footerParent.replaceChild(
        newFooterTotals.cloneNode(true),
        footerParent.querySelector(".cart_drawer__footer-totals")
      );

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = this.element.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );

        if (currentShippingBar) {
          const gift = currentShippingBar.getAttribute("data-include-gift");
          const giftContainer = this.element.querySelector(".cart__gift-wrapper");
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100 && gift == "false") {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
            if (giftContainer) {
              giftContainer.setAttribute("aria-hidden", "true");
            }

          } else if (percent == 100 && gift == "true") {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
            if (giftContainer) {
              giftContainer.setAttribute("aria-hidden", "false");
            }

          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
            if (giftContainer) {
              let addedGiftsBefore = this.element.querySelector(".gift-container");
              if (addedGiftsBefore) {
                const removeButton = addedGiftsBefore.querySelector('[data-action="remove-item"]');
                if (removeButton) {
                  removeButton.click();
                }
                const giftContainers = this.element.querySelectorAll('.gift-item');
                giftContainers.forEach(giftContainer => {
                  giftContainer.style.display = 'block';
                });
              }

              giftContainer.setAttribute("aria-hidden", "true");
            }

          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }
      this.drawer.maxHeight();
    } else {
      this.clearCartFooter(tempElement);
    }
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (this.element.querySelector(".cart-drawer__footer")) {
      this.element
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {
    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );

    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;

  }

  loadRecommendations() {


    this.recommendationLoading = true;
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );
    if (!recommendationsContainer) return;
    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}`;
    }

    if (!recommendationsContainer) return;
    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
          recommendationsContainer.setAttribute(
            "data-animation",
            "elementFadeIn"
          );
          if (window.theme.enableAnimations) {

            new RevolutionAnimation(recommendationsContainer);

          }

        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    new Swiper(".helper-recomm-swiper", {
      slidesPerView: 2,
      spaceBetween: 8,
      allowTouchMove: true,
      scrollbar: {
        el: ".scrollbar-test--cart",
        draggable: true
      },
      navigation: {
        nextEl: ".cart-recommendations__swiper-button--next",
        prevEl: ".cart-recommendations__swiper-button--prev",
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
      },
    });
  }
}
customElements.define("cart-drawer", cartDrawer);

class Discounts extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
    this.updateButtonColor();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-click=enter-vaucher]',
      this.checkDiscountCode.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="submit-code"]',
      this.checkDiscountCode.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      '[data-action="submit-code-enter"]',
      (event) => {
        if (event.key === "Enter") {
          this.checkDiscountCode(event)
        }
      }
    );

    this.delegateElement.on(
      "input",
      '[data-action="submit-code-enter"]',
      this.updateButtonColor.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="remove-code"]',
      this.removeDiscountCode.bind(this)
    );
  }

  updateButtonColor() {
    const submitButton = this.element.querySelector("#cart__dicount-submit-button");
    const discountInput = this.element.querySelector(".cart__discount-input ");

    if (submitButton && discountInput) {

      if (discountInput.value.trim() === "") {
        submitButton.classList.add('empty');


      } else {
        discountInput.style.pointerEvents = "none";
        submitButton.classList.remove('empty');
      }
    }
  }

  // input functions

  checkDiscountCode(event) {
    event.preventDefault();
    event.stopPropagation();

    // get discount code from input
    const input = this.element.querySelector(".cart__discount-input");
    const value = input?.value.trim();
    this.currentCode = value;
    if (!this.currentCode) return;

    // update session storage and set new discounts around the page
    this.setCookie('discount_code_temp', this.currentCode, 30);
    this.setCookie('discount_code', this.currentCode, 30);
    sessionStorage.setItem('discount_code', this.currentCode);

    // Apply discount to the Shopify session so the cart re-renders with updated prices
    fetch(`/discount/${encodeURIComponent(this.currentCode)}`, {
      method: 'GET',
      redirect: 'manual',
      credentials: 'same-origin',
    }).finally(() => {
      this.setTotalPrice(false);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderCart === 'function') {
        drawer.renderCart(false, false);
      }
      const mainCart = document.querySelector('main-cart');
      if (mainCart && typeof mainCart.renderCart === 'function') {
        mainCart.renderCart();
      }
    });
  }

  removeDiscountCode(event) {
    event.preventDefault();
    event.stopPropagation();
    const discountInput = this.element.querySelector("#discount");
    if (discountInput) {
      discountInput.removeAttribute('style');
      discountInput.value = '';
    }
    this.setCookie('discount_code_temp', '', 30);
    this.setCookie('discount_code', '', 30);
    sessionStorage.removeItem('discount_code');

    fetch('/discount/CLEAR', {
      method: 'GET',
      redirect: 'manual',
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .finally(() => {
        try { this.setTotalPrice(true); } catch(e) {}
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderCart === 'function') {
          drawer.renderCart(false, false);
        }
        const mainCart = document.querySelector('main-cart');
        if (mainCart && typeof mainCart.renderCart === 'function') {
          mainCart.renderCart();
        }
      });
  }

  // we use cookie instead of session
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return false;
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  simulateClick(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();

      this.element.querySelector(".cart__discount-ok-button").click();
    }
  }

  setInputStateToError() {
    this.element.classList.add("error");

    setTimeout(() => {
      this.element.classList.remove("error");
    }, 1000)
  }

  setInputStateSucces() {
    const discountWrapper = this.element.querySelector('.cart__discount-wrapper');
    const successDiv = this.element.querySelector(".cart__discount-success");

    discountWrapper.setAttribute("aria-hidden", "true");
    successDiv.setAttribute("aria-hidden", "false");
  }

  setTotalPrice(isRemove) {
    const cart = document.querySelector(".main-cart__wrapper") || document.querySelector("#cart-drawer");
    const cartItems = cart.querySelectorAll(".cart-item");
    const btn = cart.querySelector('#cart__dicount-remove-button');
    const btn2 = cart.querySelector('#cart__dicount-submit-button');
    const discountInput = cart.querySelector('#discount');

    if (isRemove) {
      if (btn2) btn2.classList.remove('hidden');
      if (btn) btn.classList.add('hidden');
      cartItems.forEach(item => {

        const discountWrapper = item.querySelector(".discount-wrapper")
        const discountName = item.querySelector(".discount-name");
        const discountAmount = item.querySelector(".discount-amount");
        if (!discountWrapper) return;
        discountName.textContent = '';
        discountAmount.textContent = '';
        discountWrapper.setAttribute('aria-visible', 'false');
        discountInput.value = '';
        cart.focus()
      });
    } else {
      btn.classList.remove('hidden')
      btn2.classList.add('hidden')
    }
  }
}

customElements.define("site-discounts", Discounts);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    if (this.element.querySelector('.SliderText--SwiperHolder') && this.element.querySelectorAll('.swiper-slide').length < 2) return;
    this.carousel = new RevolutionSwiper(this.carouselElement);

    if (this.element.classList.contains('collection__swiper-tabs-wrapper') && responsive.matchesBreakpoint("pocket")) {
      const index = this.element.querySelector('.collection__tab--active').dataset.index;
      if (this.element.dataset.template === sessionStorage.getItem("previousTemplate")) {
        this.carouselElement.swiper.translateTo(sessionStorage.getItem("previousValue"), 0)
      } else {
        this.carouselElement.swiper.slideTo(index);
      }
    }
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".banner__image-container--swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".banner__image-container--swap")
      );
    }
    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".banner__image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(".banner__image");
      } else {
        imageToReveal = imageContainers[1].querySelector(".banner__image");
      }
    }
    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace(
      "{width}x",
      "width=2600"
    );
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = "true";
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.headerTransparent = false;
    this.bigLogo = document.body.querySelector(".header-big-logo__wrapper");
    this.defaultLogo = this.element.querySelector(".header--logo-wrapper");
    this.annBar = document.querySelector('slider-announcement-bar');

    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (!document.querySelector('.banner-transparent')) {
      this.element.querySelector('.hide-logo')?.classList.remove('hide-logo');
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    this.bindEvents();
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--header-dynamic-height",
      `${visibleHeight}px`
    );
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--sticky");
  }

  bindEvents() {
    if (this.options.transparent && this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }
    if (
      this.bigLogo &&
      this.element.classList.contains("header--transparent")
    ) {
      this.toggleLogo();
    }

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);
    this.selectorsOpenedListener = this.openMenu.bind(this);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .main-links",
      this.closeMenu.bind(this),
      true
    );

    if (document.querySelector('.announcementBar--transparent') && document.querySelector('.banner-transparent') && this.element.classList.contains("header--transparent") && responsive.matchesBreakpoint('lap_and_up')) {
      this.delegateElement.on(
        "mouseenter",
        "header-component",
        () => {
          if (event.target != this.element) return;
          this.annBar.classList.add('announcement__bar-bg');
        },
        true
      );

      this.delegateElement.on(
        "mouseleave",
        "header-component",
        () => {
          if (event.target != this.element) return;
          setTimeout(() => {
            this.annBar.classList.remove('announcement__bar-bg');
          }, 150);
        },
        true
      );
    }

    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.delegateElement.on("mouseenter", "#header", this.toggleLogo.bind(this), false);
      this.delegateElement.on("mouseleave", "#header", this.toggleLogo.bind(this), false);
    }




    this.delegateElement.on(
      "mouseover",
      "[data-action='on-hover']",
      debounce(this.handleHoverInMenu.bind(this), 210),
      true
    );



    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
  }

  hoverAnnBar() {

  }

  handleHoverInMenu(event) {
    if (!event.target.getAttribute("data-handle")) return;
    const dataHandle = event.target.getAttribute("data-handle");

    const dropdownParent = event.target.closest(".desktopMenu--Dropdown");
    const productsWrapper = dropdownParent.querySelector(
      ".desktop-menu__images-hover-wrapper"
    );

    if (!dataHandle || !dropdownParent || !dropdownParent || !productsWrapper)
      return;


    let showedItem = productsWrapper.querySelector('.desktop-menu__on-hover-item[aria-hidden="false"]');
    const itemToShow = productsWrapper.querySelector(`.desktop-menu__on-hover-item[data-handle="${dataHandle}"]`);
    if (!showedItem) {
      return;
    }
    if (showedItem.getAttribute('data-handle') == dataHandle) return;



    this.changeItems(showedItem, itemToShow);

  }

  changeItems(showedItem, itemToShow) {
    // Hide the current item with fade-out animation
    if (showedItem) {

      showedItem.setAttribute('aria-hidden', 'true');
      // Listen for the transition end to remove the element from layout
      showedItem.addEventListener('transitionend', function onTransitionEnd() {


        showedItem.style.display = 'none';  // Hide the item after transition
        showedItem.removeEventListener('transitionend', onTransitionEnd);  // Clean up the event listener

        // Show the new item with fade-in animation
        if (itemToShow) {
          itemToShow.style.display = 'flex';
          setTimeout(() => {
            itemToShow.setAttribute('aria-hidden', 'false');
          }, 0); // Delay to ensure layout is recalculated
        }


      });
    }
  }

  toggleLogo(event) {
    if (!this.bigLogo || !this.defaultLogo || (event && event.target != this.element)) return;
    if (!event) {
      this.bigLogo.classList.remove("hide-logo");
      this.defaultLogo.classList.add("hide-logo");
      return;
    }

    if (this.element.classList.contains("header--transparent")) {
      if (event.type === "mouseenter") {
        this.bigLogo.classList.add("hide-logo");
        this.defaultLogo.classList.remove("hide-logo");
      } else if (event.type === "mouseleave") {
        this.bigLogo.classList.remove("hide-logo");
        this.defaultLogo.classList.add("hide-logo");
      }
    }
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    this.element.classList.remove("header--transparent");
    document.querySelector('slider-announcement-bar').classList.add('announcement__bar-bg-open');

    this.showOrHide();

    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    const scrollableElement = target.querySelector("[data-scrollable]");

    // Disable body scroll on the scrollable element inside the menu.
    setTimeout(() => {
      bodyScrollLock.disableBodyScroll(
        scrollableElement, bodyScrollLockOptions
      );
    }, 10);
  }

  showOrHide() {
    if (this.element.classList.contains("header--transparent")) {
      this.element.classList.remove("header--transparent");
      this.headerTransparent = true;
      window.headerTransparent = true;
      document.querySelector('slider-announcement-bar').classList.add('announcement__bar-bg-open');
    }

    if (this.bigLogo) {
      this.bigLogo.classList.add("hide-logo");
      this.defaultLogo.classList.remove("hide-logo");
    }
  }

  closeMenu(event, target) {
    const selectors = event.target.closest(".RevolutionSelectbox--Selectors");
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }

    if (event.type != 'menu:close') {
      this.element.dispatchEvent(
        new CustomEvent("menu:open", { bubbles: true })
      );
    }

    let menuitems = target.querySelectorAll(".mainMenu--MultipleItems");
    menuitems.forEach((item) => {
      item.classList.remove(".show");
    });

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor(true);


    bodyScrollLock.clearAllBodyScrollLocks();
  }

  toggleColor(minimize) {
    if (!this.options.transparent) return;
    if (window.pageYOffset > 25) {
      this.element.classList.add("header--scrolled");
      this.element.classList.remove("header--transparent");
      if (this.annBar) this.annBar.classList.add('announcement__bar-bg-open');
      if (this.bigLogo && !minimize) {
        this.bigLogo.classList.add("hide-logo");
        this.defaultLogo.classList.remove("hide-logo");
      }
    } else {
      this.element.classList.remove("header--scrolled");
      this.element.classList.add("header--transparent");
      if (this.annBar) this.annBar.classList.remove('announcement__bar-bg-open');
      if (this.bigLogo && !minimize) {
        this.bigLogo.classList.remove("hide-logo");
        this.defaultLogo.classList.add("hide-logo");
      }

    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.hamburger = document.querySelector(".header--hamburger");

    this.delegateElement = new Delegate(this.element);
    this.sidebarMenu = new Drawer(this.element, {
      onClose: () => {
        this.hamburger.classList.remove("is-active");

        const openSubmenus = this.element.querySelectorAll(
          '.mobile-menu__grid[aria-expanded="true"]'
        );
        openSubmenus.forEach(submenu => {
          submenu.setAttribute("aria-hidden", "true");
          submenu.setAttribute("aria-expanded", "false");
          bodyScrollLock.enableBodyScroll(submenu);
        });
        if (window.headerTransparent) {
          document.getElementById("header").toggleColor();
        }
      },
      onOpen: () => {
        this.hamburger.classList.add("is-active");
        document.getElementById("header").showOrHide();

        this.element
          .querySelector(".mobile-menu__grid--level-one")
          .setAttribute("aria-hidden", "false");
        this.element
          .querySelector(".mobile-menu__grid--level-one")
          .setAttribute("aria-expanded", "true");
      },
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='open-submenu'], [data-action='close-submenu']",
      this.toggleSubmenu.bind(this)
    );
  }

  toggleSubmenu(event, target) {
    event.preventDefault();

    const id = target.getAttribute("aria-controls");
    const submenuToShow = this.element.querySelector(`#${id}`);
    const submenuToHide = this.element.querySelector(
      '.mobile-menu__grid[aria-expanded="true"]'
    );
    submenuToShow?.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        submenuToShow?.setAttribute("aria-expanded", "true");
        bodyScrollLock.disableBodyScroll(submenuToShow, bodyScrollLockOptions);
      });
    });

    trapFocus(submenuToShow);

    submenuToHide?.setAttribute("aria-expanded", "false");
    bodyScrollLock.enableBodyScroll(submenuToHide, bodyScrollLockOptions);
    setTimeout(() => {
      submenuToHide.setAttribute("aria-hidden", "true");
    }, 255);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);
class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  bindCustomControls() {
    this.stateElement = this.element.querySelector(
      "[data-action='toggle-state']"
    );
    this.soundElement = this.element.querySelector(
      "[data-action='toggle-sound']"
    );

    if (!this.stateElement || !this.soundElement) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () =>
      this.videoPlayer.paused()
        ? this.videoPlayer.play()
        : this.videoPlayer.pause()
    );
    this.delegateElement.on("click", "[data-action='toggle-sound']", () =>
      this.videoPlayer.muted()
        ? this.videoPlayer.muted(false)
        : this.videoPlayer.muted(true)
    );

    this.videoPlayer.on("play", () =>
      this.stateElement.setAttribute("aria-label", "playing")
    );
    this.videoPlayer.on("pause", () =>
      this.stateElement.setAttribute("aria-label", "paused")
    );
    this.videoPlayer.on("volumechange", () =>
      this.soundElement.setAttribute(
        "aria-label",
        this.videoPlayer.muted() ? "muted" : "unmuted"
      )
    );
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let breakpoint = responsive.getCurrentBreakpoint();
    this.footer = document.querySelector(".mainfooterWrapper");

    if (breakpoint == "phone" || breakpoint == "tablet") {
      // this.dropdown = new Dropdown(this.element);
    }
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.footer.offsetHeight + "px"
    );
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
  }
}
customElements.define("footer-component", FooterComponent);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );
    this.pageOverlay = document.querySelector(".pageOverlay");

    this.initialization();




    setTimeout(() => { this.changeVariable(); }, 200);
    this.bindEvents();
  }

  initialization() {
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.options["slides_number"] > 1) {
      if (this.options["show_thumbnails"]) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);
    //new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.complementaryEl = this.element.querySelector(
      ".complementary-products__wrapper"
    );

    if (this.complementaryEl) {
      this.handleComplementaryProducts();
    }

    if (this.options["sticky_atc"]) {
      this.stickyAtc = this.element.querySelector(
        ".product-module__sticky-atc"
      );
      this.mainAtc = this.element.querySelector(
        ".product-module__product-atc-wrapper"
      );
      this.footer = document.querySelector(
        ".shopify-section-group-footer-group"
      );
    }

    // initialSlide in the Swiper config handles starting position;
    // variant:changed event in bindEvents() handles variant switches



    /* Notify me START*/
    this.notifyMeBtns = this.querySelectorAll('.product-module__product-atc-notify');
    this.notifyMeOverlay = this.element.querySelector(".notifyMeOverlay");

    window.addEventListener("DOMContentLoaded", () => {


      const intervalId = setInterval(() => {

        if (document.querySelector(".appikon-bis-inline-form-wrapper")) {
          clearInterval(intervalId);

          const sendButton = document.querySelector(
            "#appikon-bis-inline-form-submit"
          );


          const spanFirst = document.createElement("span");
          spanFirst.classList.add("ButtonText", "ButtonTextStart", "u-pb1");


          if (sendButton) {
            setTimeout(() => {
              sendButton.appendChild(spanFirst);

              sendButton.classList.add(
                "Button--PrimaryOnLight",
                "Button--Normal",
                "u-pb1"
              );
            }, 500);
          }
          this.notifyMeBtns.forEach(btn => {
            btn.removeAttribute('disabled');
          })



          const destContainer = this.element.querySelector(
            "#appikon-bis-inline-form-wrapper"
          );

          const notifyMeInfo = destContainer.querySelector('#appikon-bis-inline-form-footer-note');

          const closeButton = document.createElement("button");
          closeButton.classList.add("notifyMe--Close");
          closeButton.setAttribute("data-action", "notify-close");
          closeButton.innerHTML = `
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.07634 4.82574C4.17812 4.72492 4.34315 4.72492 4.44493 4.82574L8.03797 8.38499L11.5551 4.90096C11.6569 4.80013 11.8219 4.80013 11.9237 4.90096C12.0254 5.00179 12.0254 5.16526 11.9237 5.26609L8.40656 8.75012L11.9237 12.2342C12.0254 12.335 12.0254 12.4985 11.9237 12.5993C11.8219 12.7001 11.6569 12.7001 11.5551 12.5993L8.03797 9.11525L4.44493 12.6745C4.34315 12.7753 4.17812 12.7753 4.07634 12.6745C3.97455 12.5737 3.97455 12.4102 4.07634 12.3094L7.66937 8.75012L4.07634 5.19087C3.97455 5.09004 3.97455 4.92657 4.07634 4.82574Z" fill="#231F20"/>
          </svg>
          `;


          destContainer.appendChild(closeButton);
          destContainer.appendChild(notifyMeInfo);
          const atcButtons = document.querySelectorAll('.product-module__product-atc ');
          atcButtons.forEach(btn => btn.style.display = 'none');

          if (atcButtons) {
            const notifyMeButtons = document.querySelectorAll('.product-module__product-atc-notify ');
            notifyMeButtons.forEach(btn => btn.style.display = 'flex');
          }




          this.pageOverlay.addEventListener(
            "click",
            this.closeNotifyPopup.bind(this)
          );

          this.domDelegate.on(
            "click",
            '[data-action="notify-open"]',
            this.openNotifyPopup.bind(this)
          );

          this.domDelegate.on(
            "click",
            '[data-action="notify-close"]',
            this.closeNotifyPopup.bind(this)
          );

          this.element.dispatchEvent(
            new CustomEvent("notify:added", {
              bubbles: true,
              detail: document.querySelectorAll(".product-module__product-atc-notify"),
            })
          );
        }
      }, 100);

      setTimeout(() => {
        clearInterval(intervalId);
      }, 5000);
    });

    /* Notify me END */

    if (this.options["sticky_atc"]) {
      if (!this.element.querySelector(
        ".ProductAction--StickyATC"
      )) return

      this.elementToHide = this.element.querySelector(
        ".ProductAction--StickyATC"
      );
      this.elementToHide.classList.remove("show");

      this.atc = this.element.querySelector(".ScrollToATC");
      this.footer = document.querySelector(".mainfooterWrapper");

      this.showStickyAtc();
      window.addEventListener("scroll", this.showStickyAtc.bind(this));
    }
  }

  bindEvents() {
    this.domDelegate.on("price:change", this.updatePrice.bind(this));
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));
    window.addEventListener("resize", this.changeVariable.bind(this));



    this.closeNotifyPopupBinder = this.closeNotifyPopup.bind(this);
  }

  changeVariable() {

    this.element.style.setProperty('--thumb_max_height', `${this.element.querySelector('#productSwiperElement').offsetHeight}px`);
  }
  showStickyAtc() {
    if (
      window.scrollY + window.innerHeight <
      this.footer.getBoundingClientRect().top + window.scrollY &&
      window.scrollY > this.atc.getBoundingClientRect().bottom + window.scrollY
    ) {
      this.elementToHide.classList.add("show");
    } else {
      this.elementToHide.classList.remove("show");
    }
  }
  updatePrice(event) {

    const priceToBeChanged = this.element.querySelectorAll(".product-module__atc-price");

    const quantity = parseInt(this.element.querySelector('.QuantitySelector__ProductQuantity').value);

    if (event.detail.eventName === 'variant' && event.detail.plans_length === 0) {

      const newSinglePrice = parseInt(event.detail.price_raw);

      const newFinalPrice = quantity * newSinglePrice;

      const priceFormatted = Shopify.formatMoney(
        newFinalPrice,
        window.theme.moneyFormat
      )
      priceToBeChanged.forEach((price) => {
        price.innerHTML = `| ` + priceFormatted;
      });


    } else if ((event.detail.eventName === 'subs' || event.detail.plans_length > 0) && event.detail.eventName !== 'variant') {
      const newSinglePrice = parseInt(event.detail.raw);

      const newFinalPrice = quantity * newSinglePrice;

      const priceFormatted = Shopify.formatMoney(
        newFinalPrice,
        window.theme.moneyFormat
      )
      priceToBeChanged.forEach((price) => {
        price.innerHTML = `|&nbsp;` + priceFormatted;
      });

    } else {
      return;
    }

  }

  openNotifyPopup() {
    event.preventDefault();
    this.isOpen = true;

    this.notifyMeOverlay.classList.add("is-visible");

    this.domDelegate.on(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    bodyScrollLock.disableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.add("showNotifyMe");
  }


  closeNotifyPopup() {
    event.preventDefault();
    if (!this.isOpen) return;

    this.domDelegate.off(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    this.notifyMeOverlay.classList.remove("is-visible");

    bodyScrollLock.enableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.remove("showNotifyMe");

    this.isOpen = false;
  }



  async handleComplementaryProducts() {
    this.block_options = JSON.parse(
      this.complementaryEl.getAttribute("data-block-settings")
    );

    let optionToUse = this.block_options.select_type;
    this.complementaryElWrapper = this.element.querySelector(
      ".complementary-products__wrapper"
    );

    let url = `${window.routes.localeRootUrl}/recommendations/products?section_id=complementary_products_pdp&product_id=${this.options["product_id"]}&limit=10&intent=${optionToUse}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);
    let content = await response.text();
    content = new DOMParser().parseFromString(content, "text/html");
    let hasProducts;

    const contentToInsert = content.querySelector(
      ".complementary-products-section"
    );

    this.element
      .querySelector(".complementary_products_pdp-swiper")
      .appendChild(contentToInsert);

    this.carouselComplementary = this.element.querySelector(
      "#complementarySwiperElement"
    );

    if (this.carouselComplementary) {
      this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
    }

    this.childEl = this.element.querySelector(
      ".complementary-products-section .complementary-products__image-container"
    );

    if (this.childEl) {
      hasProducts = true;
    } else {
      hasProducts = false;
    }
    if (hasProducts == false) {
      this.element.querySelector('.complementary-products__wrapper').style.display = 'none';
    } else {
      this.element.querySelector('.complementary-products__wrapper').style.display = 'block';
    }
    if (this.complementaryElWrapper && hasProducts) {
      this.complementaryElWrapper.style.display = "block";

      const selectboxesComplementary = this.complementaryElWrapper.querySelectorAll('.RevolutionSelectbox');
      selectboxesComplementary.forEach(selectbox => {
        new RevolutionSelectbox(selectbox);
      })

    }
  }




  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest(".swiper-slide");
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(
      slideElement
    );

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class SubscriptionFlow extends HTMLElement {
  constructor(element) {
    super();
    element ? (this.element = element) : (this.element = this);
    this.delegateElement = new Delegate(this.element);
    this.bodyDelegate = new Delegate(document.body);

    if (this.element.querySelector('.learn-more-height-el')) {
      const learnMoreHeight = this.element.querySelector('.learn-more-height-el').offsetHeight;
      document.documentElement.style.setProperty(
        "--subs_info_height",
        `${learnMoreHeight}px`
      );
    }

    this.subscriptionSelect = this.element.querySelector(
      ".Product--SubscriptionSelect"
    );

    this.sellingPlanInput = document.body.querySelector("#selling_plan.main-plan");

    this.subsBlock = document.body.querySelector(".pdp-subscription_block");

    this.bindEvents();
  }

  bindEvents() {
    document.body.addEventListener(
      "variant:subs",
      this.refreshSubsBlock.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-info"]',
      this.toggleLearnInfo.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="subscription-change"]',
      this.toggleSubscription.bind(this)
    );
    this.delegateElement.on(
      "change",
      ".Product--SubscriptionSelect",
      this.toggleSelectSubscription.bind(this)
    );
  }

  toggleLearnInfo(event) {
    const toggleEl = this.element.querySelector('.pdp-main-subs__learn-more-content ');

    toggleEl.classList.toggle('hide-info');

  }

  refreshSubsBlock(event) {
    this.element.querySelector(".Product--SubscriptionOneTimeButton").click();
    if (event.detail.plans_length == 0) {
      this.subsBlock.setAttribute("aria-expanded", "false");
    } else {
      setTimeout(() => {
        this.subsBlock.setAttribute("aria-expanded", "true");
      }, 800);
    }
  }

  toggleSelectSubscription(e) {
    this.atcPrice = document.querySelectorAll(
      `.ProductForm--SubscriptionPrice[data-productid="${this.element.dataset.productid}"]`
    );
    this.selectPrice = document.querySelectorAll(
      `.Product--SubscriptionPrice[data-productid="${this.element.dataset.productid}"]`
    );

    var plan;
    if (e) plan = e.target.options[e.target.selectedIndex].dataset.plan;
    else
      plan =
        this.subscriptionSelect.options[this.subscriptionSelect.selectedIndex]
          .dataset.plan;

    if (this.sellingPlanInput) {

      this.sellingPlanInput.value = plan;
    }

    this.atcPrice.forEach(
      (price) =>
      (price.innerHTML =
        this.subscriptionSelect.options[
          this.subscriptionSelect.selectedIndex
        ].dataset.price)
    );
    this.selectPrice.forEach(
      (price) =>
      (price.innerHTML =
        this.subscriptionSelect.options[
          this.subscriptionSelect.selectedIndex
        ].dataset.price)
    );



    this.element.dispatchEvent(
      new CustomEvent("price:change", {
        bubbles: true,
        detail: {
          eventName: "subs",
          price:
            this.subscriptionSelect.options[
              this.subscriptionSelect.selectedIndex
            ].dataset.price,
          raw:
            this.subscriptionSelect.options[
              this.subscriptionSelect.selectedIndex
            ].dataset.priceRaw,
        },
      })
    );


  }

  //toggles between selected subscription
  toggleSubscription(e) {
    e.preventDefault();
    this.subscriptionSelect = this.element.querySelector(
      ".Product--SubscriptionSelect"
    );

    const oneTimeButton = this.element.querySelector(
      ".Product--SubscriptionOneTimeButton"
    );
    const subscriptionButton = this.element.querySelector(
      ".Product--SubscriptionButton[aria-selected='true']"
    );

    if (!oneTimeButton && !subscriptionButton) return;

    const parentElement = e.target.closest(".Product--SubscriptionOption");

    const updateSubs = document.querySelectorAll('[data-action="subs-update"]');
    updateSubs.forEach(
      (box) =>
      (box.innerHTML = parentElement.querySelector(
        ".Product--SubscriptionName"
      ).innerHTML)
    );

    if (parentElement.dataset.value === "one_time") {
      oneTimeButton.setAttribute("aria-selected", "true");
      if (subscriptionButton)
        subscriptionButton.setAttribute("aria-selected", "false");

      var sellingPlanInput = document.body.querySelector("#selling_plan");

      sellingPlanInput.value = "";
      this.element.dispatchEvent(
        new CustomEvent("price:change", {
          bubbles: true,
          detail: {
            eventName: "subs",
            price: parentElement.querySelector(".Product--SubscriptionPrice")
              .innerText,
            raw:
              parentElement.dataset.priceRaw,
          },
        })
      );
    } else if (parentElement.dataset.value !== "one_time") {
      if (subscriptionButton)
        subscriptionButton.setAttribute("aria-selected", "false");

      oneTimeButton.setAttribute("aria-selected", "false");
      parentElement.setAttribute("aria-selected", "true");

      this.toggleSelectSubscription();
    }
  }
}
customElements.define("pdp-subscription-flow", SubscriptionFlow);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.atcButtons = document.querySelectorAll(".product-module__product-atc");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);



    this.bindEvents();
    this.onQuantityChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    this.delegateBody.on("update:main_variants", this.updateMainVariants.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });


    this.delegateBody.on("notify:added", this.toggleAddButton.bind(this));
    this.updateVariantPreOrder();
    setTimeout(() => {

      this.updateVariantStatuses();
    }, 1000);
  }

  updateMainVariants(event) {
    this.currentVariant = event.detail.secelcted_variant;
    this.updateSelectedVariantsMain(event)

  }

  updateSelectedVariantsMain(event) {
    const inputs = this.element.querySelectorAll(`.inputSelectboxCheckbox`);
    const selectedOptions = event.detail.options;

    inputs.forEach(input => {
      if (selectedOptions.includes(input.value)) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    })
    this.toggleAddButton();
    this.updateVariantStatuses();
    this.updateVariantPreOrder();
  }

  refreshSubs() {
    this.element.dispatchEvent(
      new CustomEvent("variant:subs", {
        bubbles: true,
        detail: {
          plans_length: this.currentVariant["selling_plan_allocations"].length,
        },
      })
    );
  }

  updatePriceOnVariant() {
    this.element.dispatchEvent(
      new CustomEvent("price:change", {
        bubbles: true,
        detail: {
          eventName: "variant",
          price_raw:
            this.currentVariant.price,
          plans_length: this.currentVariant["selling_plan_allocations"].length,

        },
      })
    );
  }
  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton();
  }

  onVariantChange(event) {

    this.updateOptions();
    this.updateMasterId();


    this.toggleAddButton();

    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updatePriceOnVariant();
    this.updateVariantPreOrder();
    this.updateVariantStatuses();
    this.refreshSubs();
    this.updateStickyPart();

  }
  updateVariantPreOrder() {

    const inputWrappers = [...this.querySelectorAll(".SelectBox--Wrapper")];
    console.log('inputWrappers', inputWrappers);

    const checkedInputs = inputWrappers.flatMap(wrapper =>
      [...wrapper.querySelectorAll("input:checked")]
    );

    const allContinueSelling = checkedInputs.every(input => input.dataset.continueSelling === "true");

    this.sellingInfo = allContinueSelling ? 'true' : 'false';

    console.log('continueSelling:', this.sellingInfo);
  }

  updateStickyPart() {

    this.element.dispatchEvent(
      new CustomEvent("update:sticky_content", {
        bubbles: true,
        detail: {
          event_name: 'update-sticky-content',
          secelcted_variant: this.currentVariant,
          option1: this.currentVariant.option1,
          option2: this.currentVariant.option2,
          option3: this.currentVariant.option2,
          options: this.currentVariant.options
        },
      })
    );
  }

  updateOptions() {
    if (!this.element.classList.contains('sticky-variants')) {
      this.options = Array.from(
        this.querySelectorAll("select, input:checked"),
        (select) => select.value
      );
    } else {
      this.options = Array.from(
        this.element.querySelectorAll("select, input:checked"),
        (select) => select.value
      );

    }


  }


  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(`input:checked`).value === variant.option1
    );


    const inputWrappers = [...this.querySelectorAll(".SelectBox--Wrapper")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll(`input`)];

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });




  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.closest(".Selectbox").querySelector('.SelectboxLabelNormal').classList.remove('not-avaliable');
        input.removeAttribute("disabled-variant");
      } else {
        input.setAttribute("disabled-variant", "true");
        input.closest(".Selectbox").querySelector('.SelectboxLabelNormal').classList.add('not-avaliable');
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;


      return !variant.options
        .map((option, index) => {
          return this.options[index] == option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) {
      return;
    }
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        const productTitleBlock = document.querySelector('.ProductInfo--Title');
        const sourceTitleBlock = html.querySelector('.ProductInfo--Title');

        if (productTitleBlock && sourceTitleBlock) {
          productTitleBlock.innerHTML = sourceTitleBlock.innerHTML;
        }

        if (source && destinations) {
          destinations.forEach((destination) => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const quantityButton = document.querySelector(".QuantityHandler");
        if (quantityButton) {
          const source = html.querySelector(".QuantityHandler");
          if (source && quantityButton)
            quantityButton.innerHTML = source.innerHTML;
        }






        this.toggleAddButton();
      });
  }

  toggleAddButton(e) {
    if (this.element.classList.contains('sticky-variants')) return;
    let quantity = "";
    const addButton = document.querySelectorAll(".product-module__product-atc--main"),
      addButtonInner = document.querySelectorAll(
        ".product-module__product-atc--main .ButtonText"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (e) this.notifyMeButtons = e.detail;

    if (this.currentVariant) {
      if (this.currentVariant.available == false) {
        if (this.notifyMeButtons) {
          this.notifyMeButtons.forEach((btn) => {
            btn.style.display = "flex";
            btn.removeAttribute('disabled');

          });

          addButton.forEach((btn) => (btn.style.display = "none"));
        } else {
          document.querySelectorAll('.product-module__product-atc-notify').forEach((btn) => (btn.style.display = "none"));
          addButton.forEach((btn) => (btn.style.display = "flex"));
        }

        addButton.forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
          btn.classList.add("main-pdp-sold-out");
        });
        addButtonInner.forEach((btn) => {
          btn.innerHTML = window.variantStrings.soldOut;
        });
      } else {
        if (this.notifyMeButtons)
          this.notifyMeButtons.forEach((btn) => (btn.style.display = "none"));
        addButton.forEach((btn) => {
          btn.removeAttribute("disabled");
          btn.classList.remove("main-pdp-sold-out");
          btn.style.display = "flex";
        });


        addButtonInner.forEach((btn) => {
          if (window.variantInfo.show_price) {
            var priceElement =
              "<span class='product-module__atc-price u-pb1'>| " +
              Shopify.formatMoney(
                this.currentVariant.price * quantity,
                window.theme.moneyFormat
              );
            +"</span>";


            if (this.sellingInfo == "true")
              btn.innerHTML = window.variantStrings.pre_order + priceElement;
            else
              btn.innerHTML = window.variantStrings.addToCart + priceElement;
          } else {
            if (this.sellingInfo == "true")
              btn.innerHTML = window.variantStrings.pre_order;
            else
              btn.innerHTML = window.variantStrings.addToCart;
          }

        });

      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.element.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class VariantSelectsSticky extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.sellingInfo = false;

    this.bindEvents();
    this.onQuantityChange();

  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));
    this.delegateElement.on("sticky-subs:change", this.toggleAddButton.bind(this));
    this.delegateBody.on("update:sticky_content", this.updateSticky.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });


    this.delegateBody.on("notify:added", this.toggleAddButton.bind(this));
    this.updateVariantPreOrder();
    setTimeout(() => {

      this.updateVariantStatuses();
    }, 1000);
  }

  updateSticky(event) {
    this.currentVariant = event.detail.secelcted_variant;
    this.updateSelectedVariants(event)

  }
  updateSelectedVariants(event) {
    const inputs = this.element.querySelectorAll(`.RevolutionSelectbox--Item`);
    const selectedOptions = event.detail.options;

    inputs.forEach(input => {
      if (selectedOptions.includes(input.value)) {
        input.setAttribute('disabled', 'true');
        const revSelectbox = input.closest('.RevolutionSelectbox');
        revSelectbox.querySelector('.RevolutionSelectbox--Title').innerText = input.value;
      } else {
        input.removeAttribute('disabled', true);
      }
    })
    this.toggleAddButton();
    this.updateVariantStatuses();
    this.updateVariantPreOrder();

  }
  refreshSubs() {
    this.element.dispatchEvent(
      new CustomEvent("variant:subs", {
        bubbles: true,
        detail: {
          plans_length: this.currentVariant["selling_plan_allocations"].length,
        },
      })
    );
  }

  updatePriceOnVariant() {
    this.element.dispatchEvent(
      new CustomEvent("price:change", {
        bubbles: true,
        detail: {
          eventName: "variant",
          price_raw:
            this.currentVariant.price,
          plans_length: this.currentVariant["selling_plan_allocations"].length,

        },
      })
    );
  }
  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton();
  }

  onVariantChange(event) {

    this.updateOptions();

    this.updateMasterId();

    this.updateVariantPreOrder();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.updatePriceOnVariant();
    this.updateVariantStatuses();
    this.refreshSubs();
    this.updateMainPart();
  }


  updateMainPart() {

    this.element.dispatchEvent(
      new CustomEvent("update:main_variants", {
        bubbles: true,
        detail: {
          event_name: 'update-main-variants',
          secelcted_variant: this.currentVariant,
          option1: this.currentVariant.option1,
          option2: this.currentVariant.option2,
          option3: this.currentVariant.option2,
          options: this.currentVariant.options
        },
      })
    );
  }

  updateOptions() {
    this.options = Array.from(
      this.element.querySelectorAll("select, input:checked"),
      (select) => select.value
    );



  }
  updateVariantPreOrder() {

    const inputWrappers = [...this.querySelectorAll(".SelectBox--Wrapper")];
    console.log('inputWrappers', inputWrappers);

    const checkedInputs = inputWrappers.flatMap(wrapper =>
      [...wrapper.querySelectorAll("input:checked")]
    );

    const allContinueSelling = checkedInputs.every(input => input.dataset.continueSelling === "true");

    this.sellingInfo = allContinueSelling ? 'true' : 'false';

    console.log('continueSelling:', this.sellingInfo);
  }
  updateVariantStatuses() {

    if (!this.querySelector(`.RevolutionSelectbox--Item[disabled="true"]`)) return;

    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(`.RevolutionSelectbox--Item[disabled="true"]`).value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".sticky-variants-wrapper")];

    inputWrappers.forEach((option, index) => {

      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll(`.RevolutionSelectbox--Item`)];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(`.RevolutionSelectbox--Item[disabled="true"]`).value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);


    });


  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {

    listOfOptions.forEach((input) => {

      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("not-avaliable");
        input.removeAttribute("disabled-variant");
      } else {

        input.setAttribute("disabled-variant", "true");
        input.classList.add("not-avaliable");
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] == option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) {
      return;
    }
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }



  toggleAddButton(e) {

    let quantity = "";
    const addButton = document.querySelectorAll(".product-module__product-atc--main-sticky"),
      addButtonInner = document.querySelectorAll(
        ".product-module__product-atc--main-sticky .ButtonText"
      );

    if (!addButton) return;

    quantity = 1;


    if (e) this.notifyMeButtons = e.detail;

    if (this.currentVariant) {
      if (this.currentVariant.available == false) {
        if (this.notifyMeButtons) {
          this.notifyMeButtons.forEach((btn) => {
            btn.style.display = "flex";
            btn.removeAttribute('disabled');

          });

          addButton.forEach((btn) => (btn.style.display = "none"));
        } else {
          document.querySelectorAll('.product-module__product-atc-notify').forEach((btn) => (btn.style.display = "none"));
          addButton.forEach((btn) => (btn.style.display = "flex"));
        }

        addButton.forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
          btn.classList.add("main-pdp-sold-out");
        });
        addButtonInner.forEach((btn) => {
          btn.innerHTML = window.variantStrings.soldOut;
        });
      } else {
        if (this.notifyMeButtons)
          this.notifyMeButtons.forEach((btn) => (btn.style.display = "none"));
        addButton.forEach((btn) => {
          btn.removeAttribute("disabled");
          btn.classList.remove("main-pdp-sold-out");
          btn.style.display = "flex";
        });
        addButtonInner.forEach((btn) => {
          if (window.variantInfo.show_price) {

            var priceElement =
              "<span class='u-pb1 product-module__atc-price-sticky'>|&nbsp;" +
              Shopify.formatMoney(
                this.currentVariant.price * quantity,
                window.theme.moneyFormat
              );
            +"</span>";
            if (this.sellingInfo == 'true')
              btn.innerHTML = window.variantStrings.pre_order + priceElement;
            else
              btn.innerHTML = window.variantStrings.addToCart + priceElement;
          } else {
            if (this.sellingInfo == 'true')
              btn.innerHTML = window.variantStrings.pre_order;
            else
              btn.innerHTML = window.variantStrings.addToCart;
          }

        });

      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }
}
customElements.define("variant-selects-sticky", VariantSelectsSticky);


class VariantSelectsSmallCards extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);



    this.bindEvents();

  }

  bindEvents() {

    this.delegateElement.on("sticky-subs:change", this.toggleAddButton.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }


  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();
    this.updateVariantInput();

    this.refreshSubs();

  }

  updateOptions() {

    this.options = Array.from(
      this.element.querySelectorAll("select, input:checked"),
      (select) => select.value
    );



  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.closest(".Selectbox").querySelector('.SelectboxLabelNormal').removeAttribute("not-avaliable");
        input.removeAttribute("disabled-variant");
      } else {
        input.setAttribute("disabled-variant", "true");
        input.closest(".Selectbox").querySelector('.SelectboxLabelNormal').setAttribute("not-avaliable", "");
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] == option;
        })
        .includes(false);
    });
  }




  updateVariantInput() {
    if (!this.currentVariant) {
      return;
    }

    const inputMain = this.element.querySelector('.input_main_small_card');
    inputMain.value = this.currentVariant.id;

    const price = this.element.querySelector('.product-card__price-item');

    price.innerText = Shopify.formatMoney(
      this.currentVariant.price,
      window.theme.moneyFormat
    );
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }



  toggleAddButton(event) {


    const addButton = this.element.querySelectorAll(".product-card__atc-button-small");

    const subsInput = this.element.querySelector('.input_subs_small_card');

    if (!addButton) return;

    if (this.currentVariant.available == true && event) {
      if (event.detail.planId == 'no-plan') {
        subsInput.value = "";
      }
      else {
        subsInput.value = event.detail.planId;

      }

      if (this.price)
        this.price.innerText = event.detail.subPrice;




    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }
}
customElements.define("variant-selects-small-cards", VariantSelectsSmallCards);
class StickyATC extends HTMLElement {
  constructor(element) {
    super();
    element ? (this.element = element) : (this.element = this);
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.planInput = this.element.querySelector('#selling_plan');



    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("sticky-subs:change", this.updatePlan.bind(this));


  }

  updatePlan(event) {
    if (event.detail.planId == 'no-plan') {
      this.planInput.value = "";
    }
    else {
      this.planInput.value = event.detail.planId;

    }
    const stickyATC = this.element.querySelector('.pdp-sticky-atc-btn .ButtonText');
    let priceEl = "<span class='u-pb1 product-module__atc-price-sticky'>|&nbsp;" + event.detail.subPrice; +"</span>";

    if (stickyATC)
      stickyATC.innerHTML = window.variantStrings.addToCart + priceEl;
  }

}
customElements.define("sticky-atc", StickyATC);
class Cache {
  constructor(maxCacheSize = 1) {
    this.maxCacheSize = maxCacheSize; // The maximum number of results to cache
    this.cache = []; // Array to hold cached results
  }

  addData(key, data) {
    // Check if the result is already cached
    const existingIndex = this.cache.findIndex((item) => item.key === key);

    if (existingIndex !== -1) {
      // If the result is already in the cache, remove it
      this.cache.splice(existingIndex, 1);
    }

    // Add the new result to the beginning of the cache
    this.cache.unshift({ key, data });

    // Remove the oldest cached result if cache exceeds the max size
    if (this.cache.length > this.maxCacheSize) {
      this.cache.pop();
    }
  }

  getCachedData(key) {
    // Find the cached result for the given key
    const cachedItem = this.cache.find((item) => item.key === key);
    return cachedItem ? cachedItem.data : null;
  }
}
class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.queryCarouselElement = this.element.querySelector(
      "#search__query-container.swiper"
    );
    if (this.queryCarouselElement)
      this.queryCarousel = new RevolutionSwiper(this.queryCarouselElement);
    this.cachedResults = new Cache();
    this.cachedQueries = new Cache(3);

    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector(
      ".search__dynamic-content"
    );
    this.searchHeader = this.element.querySelector(".search__header");
    this.pageOverlayElement = document.getElementById("search__page-overlay");
    this.clearSearchButton = this.element.querySelector(
      ".search__clear-button"
    );
    this.queryList = this.element.querySelector(".search__queries");
    this.searchIcon = this.element.querySelector(".search__icon");

    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    new AddToCart(this.element);
    this.updateHeaderHeight();
    this.appendRecentSearches();
    this.initializeSwiper();
    this.bindEvents();
  }

  updateHeaderHeight() {
    if (!this.isOpen) {
      this.element.setAttribute("aria-hidden", false);
    }
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchHeader.offsetHeight}px`
    );
    if (!this.isOpen) {
      this.element.setAttribute("aria-hidden", true);
    }

    if (this.isOpen) {
      this.searchResultsElement.style.height = this.element.querySelector('.search__results ').scrollHeight + 'px';
    }
  }

  initializeSwiper() {
    this.carouselElement = this.searchResultsElement.querySelector(
      "[data-results] .swiper"
    );
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  bindEvents() {
    this.onInputListener = debounce(this.onInput.bind(this), 450);
    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateElement.on(
      "keydown",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    if (window.theme.showPredictiveSearches) {
      // Fast query search, not debounced
      this.delegateElement.on(
        "keydown",
        '[name="q"]',
        this.fastPredictiveSearches.bind(this)
      );
    }

    responsive.addResizeListener(this, this.updateHeaderHeight.bind(this));
    window.addEventListener("load", this.updateHeaderHeight.bind(this));

    this.searchInputElement.addEventListener("input", this.onInputListener);

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  openSearch(e) {
    e.preventDefault();

    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch(e);
      return;
    }

    this.firstSinceOpen = true;

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    this.element.removeEventListener(
      "transitionend",
      this.handleSearchCloseBinder
    );

    this.element.setAttribute("aria-hidden", false);

    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", true)
        this.isOpen = true;
        this.pageOverlayElement.classList.add("is-visible");
        bodyScrollLock.disableBodyScroll(
          this.element.querySelector("[data-scrollable]"),
          bodyScrollLockOptions
        );
        document.body.classList.add('scrollLock');
      })
    );

    this.setWidthOfSearchDropdown("open");

    // Focus on search input element after delay
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
      }
    }, 200);

    // If header is transparent, remove it's transparency
    const header = document.querySelector(".header--transparent");
    if (header) {
      header.style.transition = "none";
      header.classList.remove("header--transparent");
      document.querySelector('slider-announcement-bar').classList.add('announcement__bar-bg-open');
      window.headerTransparent = true;
      setTimeout(() => {
        header.style.transition = "";
      }, 50);
    }

    if (responsive.matchesBreakpoint('pocket')) {
      document.getElementById('header').toggleColor();
    }

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  setWidthOfSearchDropdown(string) {
    if (string === "open") {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        const scrollbarWidth = window
          .getComputedStyle(document.body)
          .getPropertyValue("padding-right");
        this.element.style.width = `calc(100% - ${scrollbarWidth})`;
      }
    } else {
      this.element.style.width = `100%`;
    }
  }

  closeSearch(e) {
    if (e) {
      e.preventDefault();
    }
    if (!this.isOpen) {
      return;
    }

    this.clearScrollLock = true;
    if (e && e.type === "close:search") {
      this.clearScrollLock = false;
    }

    this.minimize = false;
    if (e && e.target.closest('[data-action="open-search"]')) {
      this.minimize = true;
    }

    // Hide search dropdown
    this.element.setAttribute("aria-expanded", false);
    this.element.addEventListener(
      "transitionend",
      this.handleSearchCloseBinder
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.isOpen = false;
  }

  handleSearchClose(e) {
    if (e.propertyName != "transform" && e.propertyName != "opacity") return;
    this.element.setAttribute("aria-hidden", true);
    this.element.removeEventListener(
      "transitionend",
      this.handleSearchCloseBinder
    );

    if (window.headerTransparent) {
      document.getElementById("header").toggleColor(this.minimize);
    }
    this.minimize = false;

    this.resetSearch();
    if (this.clearScrollLock) {
      document.body.classList.remove('scrollLock');
      bodyScrollLock.enableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
    }

    this.clearScrollLock = true;

    this.setWidthOfSearchDropdown();
  }

  async onInput(e) {
    this.lastInputValue = e.target.value;

    // Check whether user clicked on a query
    if (e.target.hasAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = e.target.getAttribute("data-value");
      this.searchInputElement.setAttribute("value", this.lastInputValue);
      this.searchInputElement.value = this.lastInputValue;
    } else if (this.lastInputValue === "") {
      this.resetSearch();
      return;
    }

    const cachedResults = this.cachedResults.getCachedData(this.lastInputValue);

    if (!cachedResults) {
      try {
        const response = await fetch(
          `${routes.predictive_search_url}?q=${encodeURIComponent(
            this.lastInputValue
          )}&resources[limit_scope]=each&section_id=search-predictive&resources[options][fields]=title,product_type,variants.title,body,tag,vendor,variants.sku&resources[type]=product,article`
        );

        if (!response.ok) {
          throw new Error(response.status);
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-search-predictive");

        const searchResults = resultsMarkup.querySelector(".search__results");
        if (searchResults) {
          this.cachedResults.addData(this.lastInputValue, searchResults);
        }

        await this.appendResults(searchResults);
      } catch (error) {
        console.error("Failed to conduct a search.", error);
        if (error?.code === 20) {
          return;
        }

        throw error;
      }
    } else {
      await this.appendResults(cachedResults);
    }

    this.initializeSwiper();
    this.saveRecentSearch();
  }

  hideOrShowClearButton(string) {
    if (string === "show") {
      this.clearSearchButton.setAttribute("aria-hidden", "false");
      if (responsive.matchesBreakpoint("pocket")) {
        this.searchIcon.style.display = "none";
      }
    } else {
      this.clearSearchButton.setAttribute("aria-hidden", "true");
      if (responsive.matchesBreakpoint("pocket")) {
        this.searchIcon.style.display = "";
      }
    }
  }

  appendResults(searchResults) {
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    return new Promise((resolve, reject) => {
      const oldResults =
        this.searchResultsElement.querySelector("[data-results]");

      oldResults.classList.remove("visible");
      oldResults.classList.add("hidden");
      searchResults.classList.remove("visible");
      searchResults.classList.add("hidden");

      const _this = this;

      if (this.element.getAttribute("aria-expanded") == "false") {
        const newResults =
          _this.searchResultsElement.querySelector("[data-results]");
        newResults.classList.add("visible");
        newResults.classList.remove("hidden");
      } else {
        const height = this.searchResultsElement.getBoundingClientRect().height;
        const paddingBottom = parseFloat(getComputedStyle(this.searchResultsElement).paddingBottom);

        if (responsive.matchesBreakpoint('lap_and_up')) {
          this.searchResultsElement.style.height = height - paddingBottom + 'px';
        }

        oldResults.addEventListener("transitionend", function onFadeOutEnd() {
          oldResults.removeEventListener("transitionend", onFadeOutEnd);

          _this.searchResultsElement.replaceChild(searchResults, oldResults);


          const newResults =
            _this.searchResultsElement.querySelector("[data-results]");

          requestAnimationFrame(() => {
            newResults.classList.add("visible");
            newResults.classList.remove("hidden");
            if (responsive.matchesBreakpoint('lap_and_up')) {
              _this.searchResultsElement.style.height = searchResults.scrollHeight + 'px';
            }
          });

          resolve();
        });
      }
    });
  }

  async resetSearch() {
    this.hideOrShowClearButton("hide");
    await this.appendResults(
      this.initialSearchLayout.querySelector(".search__results").cloneNode(true)
    );
    this.appendRecentSearches();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    this.initializeSwiper();
    this.clearSearchButton.setAttribute("aria-hidden", "true");
    this.searchInputElement.focus();
  }

  saveRecentSearch() {
    if (!window.theme.showRecentSearches) return;

    if (this.lastInputValue.length > 3) {
      var searchTerms = JSON.parse(localStorage.getItem("searchTerms") || "[]");

      // If it doesn't already exist inside the array, push it top the beginning
      if (!searchTerms.includes(this.lastInputValue)) {
        searchTerms.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerms.slice(0, 4))
        );
      } catch (error) { }
    }
  }

  appendRecentSearches() {
    if (!window.theme.showRecentSearches) return;

    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let appendString = "";

    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabindex='0' class='u-p2 search__query-recent swiper-slide hot-spot-mini underline' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      this.element.querySelector(".search__results-list--recent").innerHTML =
        appendString;
    } else {
      this.element.querySelector(".search__results--recent").style.display =
        "none";
    }
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".contact__block-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".contact__block-button").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class MainCart extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    new AddToCart(this.element);
    this.updateGiftContainer = this.updateGiftContainer.bind(this);
  }

  connectedCallback() {
    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this)
    );
    this.updateGiftContainer();
  }

  async updateItemQuantity(event, target) {
    if (event) {
      event.preventDefault();
    }

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const cartAmount = data.total_price;

      this.checkShippingBarAndRemoveGifts(cartAmount);

    } catch (error) {
      console.error("Failed to update item quantity:", error);
    }
  }

  checkShippingBarAndRemoveGifts(cartAmount) {
    const currentShippingBar = this.element.querySelector(
      ".cart-drawer__shipping-progress-bar"
    );
    const checkamount = currentShippingBar.getAttribute("data-limit-amount");
    if (!currentShippingBar) {
      location.reload();
    }

    if (cartAmount < checkamount) {
      const giftContainer = this.element.querySelector(".gift-container");
      if (giftContainer) {
        const items = giftContainer.querySelectorAll(".cart-item");
        if (items) {
          items.forEach(item => {
            const remove = item.querySelector("[data-action='remove-item']");
            if (remove) {
              remove.click()
            }
          });
        }
      } else {
        location.reload();
      }
    } else {
      location.reload();
    }
  }

  updateGiftContainer() {
    const currentShippingBar = this.element.querySelector(
      ".cart-drawer__shipping-progress-bar"
    );

    if (!currentShippingBar) return;
    const gift = currentShippingBar.getAttribute("data-include-gift");
    const giftContainer = this.element.querySelector(".cart__gift-wrapper");

    if (currentShippingBar) {
      let percent = currentShippingBar.dataset.percent;
      if (percent > 100) {
        percent = 100;
      }
      currentShippingBar.dataset.percent = percent;
      currentShippingBar.style.width = `${percent}%`;
      if (percent == 100 && gift == "false") {
        if (giftContainer) {
          giftContainer.setAttribute("aria-hidden", "true");
        }

      } else if (percent == 100 && gift == "true") {
        if (giftContainer) {
          giftContainer.setAttribute("aria-hidden", "false");
        }
      } else {
        if (giftContainer) {
          giftContainer.setAttribute("aria-hidden", "true");
        }
      }
    }
  }
}

customElements.define("main-cart", MainCart);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.backgroundImage = document.querySelector(
      ".newsletter-popup_background_image-holder"
    );
    if (this.backgroundImage) {
      this.pageOverlayElement = this.backgroundImage;
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
      localStorage.setItem("show_popup_tag", false);
    }


    if (
      this.element.dataset.signup === "true" &&
      localStorage.getItem("show_popup_tag") !== "false"
    ) {
      document
        .getElementById("newsletter-popup__tag")
        .setAttribute("aria-hidden", false);
      this.delegateBody.on(
        "click",
        "[data-action='open-newsletter']",
        this.openNewsletter.bind(this)
      );
      this.delegateBody.on(
        "click",
        "[data-action='close-tag']",
        this.closeNewsletterTag.bind(this)
      );
    }

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      if (this.element.dataset.popup === "false") return;
      this.handleOpenOptions();
    }
  }

  closeNewsletterTag(e) {
    localStorage.setItem("show_popup_tag", false);
    e.target
      .closest('[data-action="open-newsletter"]')
      .setAttribute("aria-hidden", true);
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter(e) {
    if (e && e.target.closest('[data-action="close-tag"]')) return;
    const delay = e ? 0 : 1000 * this.options.delay;
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");

      document.body.classList.add("scrollLock");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, delay);
  }

  closeNewsletter = () => {
    event.preventDefault();

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"));
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-tab"]',
      this.toggleTab.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-register"]',
      this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "recoverFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "true");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "false");
    } else {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-visible", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-visible", "true");
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      // Manually trigger the hCaptcha
      window.hcaptcha.execute();

      // Add a delay and wait for the CAPTCHA to finish, then retrieve the response
      const interval = setInterval(function () {
        const captchaToken = window.hcaptcha.getResponse(); // Get the hCaptcha token

        if (captchaToken) {
          clearInterval(interval); // Stop checking once the token is available

          // Create the request body with the email and hCaptcha token
          const requestBody = {
            email: _this.element.querySelector("#RecoverEmail").value, // Use _this for class scope
            "h-captcha-response": captchaToken, // Include hCaptcha token here
          };

          event.target.querySelector(".itemLoader").classList.add("is-visible");

          // Send the AJAX request
          (async function () {
            try {
              const response = await fetch(registrationEndpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              });

              const responseText = await response.text();
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = responseText;

              if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
                _this.element.querySelector(
                  "#recoverFlex .accountDrawer--SuccessSpace"
                ).innerHTML = "";
                _this.element.querySelector(
                  "#recoverFlex .accountDrawer--ErrorSpace"
                ).innerHTML = tempDiv.querySelector(
                  "#RecoverEmail-email-error"
                ).innerHTML;
              } else if (responseText.indexOf("recoverSuccess") !== -1) {
                _this.element.querySelector(
                  "#recoverFlex .accountDrawer--ErrorSpace"
                ).innerHTML = "";
                _this.element.querySelector(
                  "#recoverFlex .accountDrawer--SuccessSpace"
                ).innerHTML =
                  tempDiv.querySelector("#recoverSuccess").innerHTML;
              }

              event.target
                .querySelector(".itemLoader")
                .classList.remove("is-visible");
            } catch (error) {
              console.log(
                "An error occurred during the account recovery request:",
                error
              );
            }
          })();
        }
      }, 500); // Check every 500 milliseconds if the CAPTCHA token is available
    } else {
      // hCaptcha does not exist, proceed without hCaptcha
      const requestBody = {
        email: _this.element.querySelector("#RecoverEmail").value, // Use _this for class scope
      };

      event.target.querySelector(".itemLoader").classList.add("is-visible");

      // Send the AJAX request without hCaptcha
      (async function () {
        try {
          const response = await fetch(registrationEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;

          if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
            _this.element.querySelector(
              "#recoverFlex .accountDrawer--SuccessSpace"
            ).innerHTML = "";
            _this.element.querySelector(
              "#recoverFlex .accountDrawer--ErrorSpace"
            ).innerHTML = tempDiv.querySelector(
              "#RecoverEmail-email-error"
            ).innerHTML;
          } else if (responseText.indexOf("recoverSuccess") !== -1) {
            _this.element.querySelector(
              "#recoverFlex .accountDrawer--ErrorSpace"
            ).innerHTML = "";
            _this.element.querySelector(
              "#recoverFlex .accountDrawer--SuccessSpace"
            ).innerHTML = tempDiv.querySelector("#recoverSuccess").innerHTML;
          }

          event.target
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        } catch (error) {
          console.log(
            "An error occurred during the account recovery request:",
            error
          );
        }
      })();
    }
  }

  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";

    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      // Manually trigger the hCaptcha
      window.hcaptcha.execute();

      // Add a delay and wait for the CAPTCHA to finish, then retrieve the response
      const interval = setInterval(function () {
        const captchaToken = window.hcaptcha.getResponse(); // Get the hCaptcha token

        if (captchaToken) {
          clearInterval(interval); // Stop checking once the token is available

          // Create the request body with the registration data and hCaptcha token
          const requestBody = {
            customer: {
              first_name: _this.element.querySelector(
                "#register #RegisterForm-FirstName"
              ).value,
              email: _this.element.querySelector(
                "#register #RegisterForm-email"
              ).value,
              password: _this.element.querySelector(
                "#register #RegisterForm-password"
              ).value,
            },
            "h-captcha-response": captchaToken, // Include the hCaptcha token here
          };

          event.target.querySelector(".itemLoader").classList.add("is-visible");

          // Send the AJAX request
          (async function () {
            try {
              const response = await fetch(registrationEndpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              });

              const responseText = await response.text();

              if (responseText.indexOf("registerErrors") !== -1) {
                console.log("Error occurred during registration");
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = responseText;

                _this.element.querySelector(
                  "#register .accountDrawer--ErrorSpace"
                ).innerHTML =
                  tempDiv.querySelector(".registerErrors").innerHTML;
              } else {
                location.href = window.routes.account_url;
              }

              event.target
                .querySelector(".itemLoader")
                .classList.remove("is-visible");
            } catch (error) {
              console.log(
                "An error occurred during the registration request:",
                error
              );
            }
          })();
        }
      }, 500); // Check every 500 milliseconds if the CAPTCHA token is available
    } else {
      // hCaptcha does not exist, proceed without hCaptcha
      const requestBody = {
        customer: {
          first_name: _this.element.querySelector(
            "#register #RegisterForm-FirstName"
          ).value,
          email: _this.element.querySelector("#register #RegisterForm-email")
            .value,
          password: _this.element.querySelector(
            "#register #RegisterForm-password"
          ).value,
        },
      };

      event.target.querySelector(".itemLoader").classList.add("is-visible");

      // Send the AJAX request without hCaptcha
      (async function () {
        try {
          const response = await fetch(registrationEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();

          if (responseText.indexOf("registerErrors") !== -1) {
            console.log("Error occurred during registration");
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = responseText;

            _this.element.querySelector(
              "#register .accountDrawer--ErrorSpace"
            ).innerHTML = tempDiv.querySelector(".registerErrors").innerHTML;
          } else {
            location.href = window.routes.account_url;
          }

          event.target
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        } catch (error) {
          console.log(
            "An error occurred during the registration request:",
            error
          );
        }
      })();
    }
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      // Manually trigger the hCaptcha
      window.hcaptcha.execute();

      // Add a delay and wait for the CAPTCHA to finish, then retrieve the response
      const interval = setInterval(function () {
        const captchaToken = window.hcaptcha.getResponse(); // Get the hCaptcha token

        if (captchaToken) {
          clearInterval(interval); // Stop checking once the token is available

          // Create the request body with login credentials and hCaptcha token
          const requestBody = {
            customer: {
              email: _this.element.querySelector(
                "#customer_login #CustomerEmail"
              ).value,
              password: _this.element.querySelector(
                "#customer_login #CustomerPassword"
              ).value,
            },
            "h-captcha-response": captchaToken, // Include the hCaptcha token here
          };

          event.target
            .closest("form")
            .querySelector(".itemLoader")
            ?.classList.add("is-visible");

          // Send the AJAX request
          (async function () {
            try {
              const response = await fetch(loginEndpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              });

              const responseText = await response.text();

              if (responseText.indexOf("loginError") !== -1) {
                console.log("Incorrect email or password");
                const tempDiv = document.createElement("div");

                tempDiv.innerHTML = responseText;

                _this.element.querySelector(
                  "#login .accountDrawer--ErrorSpace"
                ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${tempDiv.querySelector(".AlertError").innerHTML
                }</div>`;
              } else {
                location.href = window.routes.account_url;
              }

              event.target
                .closest("form")
                .querySelector(".itemLoader")
                ?.classList.remove("is-visible");
            } catch (error) {
              console.log("An error occurred during the login request:", error);
            }
          })();
        }
      }, 500); // Check every 500 milliseconds if the CAPTCHA token is available
    } else {
      // hCaptcha does not exist, proceed without hCaptcha
      const requestBody = {
        customer: {
          email: _this.element.querySelector("#customer_login #CustomerEmail")
            .value,
          password: _this.element.querySelector(
            "#customer_login #CustomerPassword"
          ).value,
        },
      };

      event.target
        .closest("form")
        .querySelector(".itemLoader")
        ?.classList.add("is-visible");

      // Send the AJAX request without hCaptcha
      (async function () {
        try {
          const response = await fetch(loginEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();

          if (responseText.indexOf("loginError") !== -1) {
            console.log("Incorrect email or password");
            const tempDiv = document.createElement("div");

            tempDiv.innerHTML = responseText;

            _this.element.querySelector(
              "#login .accountDrawer--ErrorSpace"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${tempDiv.querySelector(".AlertError").innerHTML
            }</div>`;
          } else if (
            responseText.indexOf("shopify-challenge__container") !== -1
          ) {
            location.href = "/challenge";
          } else {
            location.href = window.routes.account_url;
          }

          event.target
            .closest("form")
            .querySelector(".itemLoader")
            ?.classList.remove("is-visible");
        } catch (error) {
          console.log("An error occurred during the login request:", error);
        }
      })();
    }
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(
      '.accountDrawer--Tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => {
      tab.setAttribute("aria-expanded", "false");
    });

    const dataId = event.target.dataset.id;
    this.element
      .querySelectorAll(`.accountDrawer--Tab[data-id="${dataId}"]`)
      .forEach((el) => el.setAttribute("aria-expanded", "true"));

    allContent.forEach((content) => {
      content.setAttribute("aria-visible", "false");
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    this.delegateBody = new Delegate(document.body);

    if (responsive.matchesBreakpoint("lap_and_up")) {
      if (this.selectBoxes.length > 0) {
        this.selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (this.selectBoxes.length > 0) {
        this.selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, true);
        });
      }
    }

    this.bindEvents();
  }

  bindEvents() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      responsive.addResizeListener(this, this.calculateLeftPadding.bind(this));
      this.delegateBody.on('selectbox:open', this.calculateLeftPadding.bind(this));
      this.calculateLeftPadding();
    }
  }

  calculateLeftPadding() {
    this.selectBoxes.forEach((element) => {
      const leftPosition = element
        .querySelector(".RevolutionSelectbox--Button")
        .getBoundingClientRect().left;
      element.querySelector(
        ".RevolutionSelectbox--InnerContent"
      ).style.paddingLeft = leftPosition + "px";
    });
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class LegalSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.clicked = false;

    if (new Responsive().matchesBreakpoint("pocket")) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}
customElements.define("legal-section", LegalSection);

class faqSection extends HTMLElement {
  constructor() {
    super();

    // Initialize elements and delegates
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.searchInput = this.element.querySelector(".faq__search-input");
    this.termsBlocks = document.querySelectorAll(".faq__block");
    this.noResultsElement = document.querySelector("#faq__results--none");
    this.clearSearchButton = this.element.querySelector(".faq__clear-button");

    // Initialize the Swiper carousel
    if (responsive.matchesBreakpoint("pocket")) {
      this.carousel = new RevolutionSwiper(
        this.element.querySelector("[data-swiper-settings]")
      );
    }
    // Bind events to the elements
    this.bindEvents();
    this.handleScroll();
  }

  // Method to bind events
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="handle-click"]',
      this.handleClick.bind(this)
    );
    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.handleSearch.bind(this)
    );

    this.delegateElement.on(
      "input",
      ".faq__search-input",
      this.toggleClearButton.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.clearSearchInput.bind(this)
    );
  }
  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();

    // Reset visibility if search input is empty
    if (searchTerm === "") {
      this.termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
        const questions = block.querySelectorAll(".faq__block-content");
        questions.forEach((content) => content.classList.remove("is-hidden"));
      });
      this.noResultsElement.classList.add("is-hidden");
      return;
    }

    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const title = block
        .querySelector(".faq__block--heading")
        .textContent.toLowerCase();
      const questions = block.querySelectorAll(".faq__block-content");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        // If the heading matches, display all content in this block
        block.classList.remove("is-hidden");
        questions.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        // If only `faq__block-content` matches
        questions.forEach((questionWrapper) => {
          const questionText = questionWrapper.textContent.toLowerCase();
          if (questionText.includes(searchTerm)) {
            questionWrapper.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            questionWrapper.classList.add("is-hidden");
          }
        });

        // Show or hide the block based on matching content
        if (blockMatch) {
          block.classList.remove("is-hidden");
        } else {
          block.classList.add("is-hidden");
        }
      }

      if (blockMatch) hasMatch = true;
    });

    // Display 'no results' message if nothing matched
    if (!hasMatch) {
      this.noResultsElement.classList.remove("is-hidden");
    } else {
      this.noResultsElement.classList.add("is-hidden");
    }
  }

  // Method to handle click events
  handleClick(event) {
    // Set clicked data attribute for managing state
    this.element.dataset.clicked = "true";

    // Remove current highlighting from all links and add it to the clicked one
    const allLinks = this.element.querySelectorAll(".Button");

    allLinks.forEach((item) => item.classList.remove("is-active"));
    event.target.classList.add("is-active");

    // Reset the clicked state after a short delay
    setTimeout(() => {
      this.element.dataset.clicked = "false";
    }, 400);
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".is-active");
    linkedItems.forEach((item) => item.classList.remove("is-active"));
  }

  toggleClearButton() {
    if (this.searchInput.value.trim() === "") {
      this.clearSearchButton.style.opacity = "0";
    } else {
      this.clearSearchButton.style.opacity = "1";
    }
  }

  clearSearchInput() {
    this.searchInput.value = "";
    this.toggleClearButton();
    this.handleSearch();
  }

  handleScroll() {

    // Skip if an item was recently clicked
    if (this.element.dataset.clicked === "true") return;
    // Elements to handle during scroll
    const faqSubheaders = this.element.querySelectorAll(".faq__block--heading");

    const threshold = 100;

    // Check if scrolled to the bottom
    const isAtBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 5;

    if (isAtBottom) {
      // Remove all link highlights and select the last anchor element
      this.removeAllLinks();
      const lastAnchor = this.element.querySelector(
        ".faq__navigation a:last-of-type"
      );
      if (lastAnchor) lastAnchor.classList.add("is-active");
      return;
    }

    // Loop through subheaders to highlight relevant links based on scroll position
    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );

      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        // Remove highlighting from all links and highlight the current section
        this.removeAllLinks();
        const faqSectionId = faqSubheader.closest(".faq__block").id;
        const anchorElements = this.element.querySelectorAll(
          `a[href="#${faqSectionId}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("is-active");
          // Adjust slide position for mobile view if not in active view
          if (
            new Responsive().matchesBreakpoint("pocket")
          ) {
            this.carousel.swiperElement.slideTo(parseInt(item.dataset.index));
          }
        });
      }
    });
  }
}

customElements.define("section-faq", faqSection);

class Loader extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.element.style.background = this.element.dataset.background;

    if (this.dataset.first === "true") {
      // Checks if we opened site in a new tab
      const loaderShown = localStorage.getItem("loader_shown");
      localStorage.setItem("loader_shown", "true");

      if (loaderShown) {
        this.element.remove();
        return;
      }
    } else {
      // Checks if we refreshed the page
      const pageAccessedByReload =
        (window.performance.navigation &&
          window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType("navigation")
          .map((nav) => nav.type)
          .includes("reload");

      // Checks if we opened site in a new tab
      const isNewTab = sessionStorage.getItem("is_old_tab") != "true";
      sessionStorage.setItem("is_old_tab", "true");

      if (!isNewTab && !pageAccessedByReload) {
        this.element.remove();
        return;
      }
    }

    this.domContentLoaded = false;
    this.animationEnded = false;

    this.lottiePlayer = this.element.querySelector("lottie-player");
    bodyScrollLock.disableBodyScroll(document.body, bodyScrollLockOptions);

    this.bindEvents();
  }

  bindEvents() {
    this.onAnimationEndBinder = this.onAnimationEnd.bind(this);
    this.lottiePlayer.addEventListener("complete", this.onAnimationEndBinder);

    document.addEventListener("DOMContentLoaded", () => {
      this.domContentLoaded = true;
      if (this.animationEnded) {
        this.endAnimation();
      }
    });
  }

  endAnimation() {
    this.element.classList.add("hide");
    this.lottiePlayer.removeEventListener(
      "complete",
      this.onAnimationEndBinder
    );
    bodyScrollLock.clearAllBodyScrollLocks();
    setTimeout(() => {
      this.element.display = "none";
    }, 500);
  }

  onAnimationEnd() {
    this.animationEnded = true;
    if (this.domContentLoaded) {
      this.endAnimation();
    }
  }
}
customElements.define("loader-element", Loader);

function replaceBreadcrumbsText() {
  const breadcrumbs = document.querySelectorAll(".breadcrumbs__list");
  breadcrumbs.forEach((breadcrumb) => {
    breadcrumb.classList.remove("breadcrumbs__list--cut");
    if (breadcrumb.scrollWidth > breadcrumb.clientWidth) {
      breadcrumb.classList.add("breadcrumbs__list--cut");
    }
  });
}

window.addEventListener("load", replaceBreadcrumbsText);
responsive.addResizeListener(this, replaceBreadcrumbsText);

class InfiniteScroll {
  constructor(container, paginationElement, restoreState) {
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;
    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;

    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload =
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)
      .dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {
      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.searchTypes = [
      { id: "collection__main-grid", type: "product" },
      { id: "collection__main-grid-articles", type: "article" },
    ];
  }

  connectedCallback() {
    this.filterBar = this.element.querySelector(".collection__nav-filter-bar");
    this.loadType = this.element.dataset.load;

    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
    this.initialize();
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.bindObservers();
    } else {
      this.delegateElement.on("click", '[data-action="load-initial"]', this.handleClick.bind(this));
    }

    if (window.location.pathname.includes('/view/article-primary')) {
      this.toggleGridBasedOnUrl();
    }
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener("popstate", this.toggleGridBasedOnUrl.bind(this));
  }

  bindObservers() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    this.searchTypes.forEach((searchType) => {
      const container = document.getElementById(searchType.id);
      const paginationElement = container.querySelector(".infinite-scroll");
      if (!container || !paginationElement) return;

      // Select the second-to-last child
      const children = container.children;
      const target = children[children.length - 2];

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paginationElement.remove();
            observer.unobserve(target);

            this.fetchSearchType(searchType.id, searchType.type);
          }
        });
      }, observerOptions);

      observer.observe(target);
    });
  }

  async handleClick(e) {
    e.preventDefault();
    e.target.querySelector(".itemLoader").classList.add("is-visible");
    const paginationElement = e.target.parentElement;

    const matchingObject = this.searchTypes.find(
      (item) => item.type === paginationElement.dataset.type
    );
    await this.fetchSearchType(matchingObject.id, matchingObject.type);

    paginationElement.remove();
  }

  async fetchSearchType(gridContainerId, type) {
    const section = document.getElementById(gridContainerId);
    if (!section) return;

    let path = window.location.pathname;
    for (const type of this.searchTypes) {
      const pattern = `/view/${type.type}s`;
      if (path.includes(pattern)) {
        path = path.replace(pattern, "");
        break;
      }
    }

    const sectionId = section.dataset.id;
    const searchTerms = this.element.dataset.searchTerms;
    const url = `${path}?section_id=${sectionId}&${searchTerms}&type=${type}&page=2`;

    await this.renderSectionFromFetch(url, gridContainerId, section);
  }

  async renderSectionFromFetch(url, gridContainerId) {
    try {
      const response = await fetch(url);
      const html = await response.text();

      this.renderGrid(html, gridContainerId);
    } catch (error) {
      console.error("Error fetching section on main search:", error);
    }
  }

  renderGrid(html, gridContainerId) {
    const newGridContent = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(gridContainerId);
    if (!newGridContent) return;

    const gridContainer = document.getElementById(gridContainerId);
    gridContainer.insertAdjacentHTML("beforeend", newGridContent.innerHTML);

    const newPaginationElement =
      newGridContent.querySelector(".infinite-scroll");
    if (!newPaginationElement) return;
    new InfiniteScroll(`#${gridContainerId}`, `#${newPaginationElement.id}`);
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute("aria-controls");

    this.updatePath(id);

    if (this.filterBar) {
      id.includes("product")
        ? this.filterBar.setAttribute("aria-hidden", "false")
        : this.filterBar.setAttribute("aria-hidden", "true");
    }

    const gridsToHide = this.element.querySelectorAll(
      '.collection__grid[aria-hidden="false"]'
    );
    const gridToShow = this.element.querySelector(`#${id}`);
    const prevActiveButton = this.element.querySelector(
      '[data-action="toggle-collection"][aria-expanded="true"]'
    );

    gridsToHide.forEach((grid) => grid.setAttribute("aria-hidden", "true"));
    gridToShow.setAttribute("aria-hidden", "false");

    prevActiveButton.setAttribute("aria-expanded", "false");
    target.setAttribute("aria-expanded", "true");
  }

  toggleGridBasedOnUrl() {
    if (window.location.pathname.includes('/view/article-primary')) {
      this.element.querySelector('[aria-controls="collection-article"]')?.click();
    } else {
      this.element.querySelector('[aria-controls="collection-product"]')?.click();
    }
  }

  // Depending on where user refreshes, show them the type of results they were on before refreshing
  updatePath(id) {
    const url = new URL(window.location.href);
    const pathname = url.pathname;
    let updatedPathname = pathname;

    if (id.includes('article') && pathname.includes('/search') && !pathname.includes('/view/article-primary')) {
      updatedPathname = pathname.replace('/search', '/search/view/article-primary');
      window.history.replaceState({}, '', updatedPathname + url.search);
    } else if (!id.includes('article') && pathname.includes('/view/article-primary')) {
      updatedPathname = pathname.replace('/view/article-primary', '');
      window.history.replaceState({}, '', updatedPathname + url.search);
    }
  }
}
customElements.define("search-component", MainSearch);

class SliderAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));

    this.announcementBar = document.querySelector(".announcementBar");
    this.updateVisibleHeight();
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    if (this.options.totalBlocks < 6) {
      this.animateBig = false;
    } else {
      this.animateBig = true;
    }

    if (this.options.totalBlocks > 0 && this.options.enableAnimation) {
      this.announcementBar1 = this.element.querySelector(
        "#announcementBar--SwiperWrapperOne"
      );
      this.announcementBar2 = this.element.querySelector(
        "#announcementBar--SwiperWrapperTwo"
      );
      this.slides = this.element.querySelectorAll(".announcementBar--Slide");
      this.fadeToggle = false;
      this.firstAnimation = true;

      window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
      this.handleSmallAnimation();
    }
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  toggleFade() {
    this.announcementBar2.style.display = "flex";

    if (this.fadeToggle) {
      this.announcementBar1.classList.remove("fade-in");
      this.announcementBar2.classList.add("fade-in");
    } else {
      this.announcementBar1.classList.add("fade-in");
      this.announcementBar2.classList.remove("fade-in");
    }

    this.fadeToggle = !this.fadeToggle;
  }

  fadeBig() {
    // Initially fade in the first bar
    this.announcementBar1.classList.add("fade-in");

    this.slides.forEach((slide) => (slide.style.visibility = "visible"));

    if (this.animateBig)
      this.barsTimeout = setInterval(
        () => this.toggleFade(),
        this.options.interval
      );
  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (currentSlideIndex > 0) {
        mySlides[currentSlideIndex - 1].classList.remove("fade-in");
      }

      mySlides[currentSlideIndex].classList.add("fade-in");

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove("fade-in");
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  stopFadeBig() {
    this.announcementBar1.style.display = "none";
    this.announcementBar2.style.display = "none";

    this.announcementBar1.classList.remove("fade-in");
    this.announcementBar2.classList.remove("fade-in");

    setTimeout(() => {
      this.announcementBar1.style.display = "flex";
      this.announcementBar2.style.display = "flex";
    }, 100);

    clearTimeout(this.barsTimeout);
  }

  stopFadeSmall() {
    this.slides.forEach((slide) => {
      if (slide.classList.contains("fade-in")) {
        slide.classList.remove("fade-in");
      }
    });
    clearTimeout(this.slidesTimeout);
  }

  handleBigAnimation() {
    if (!this.firstAnimation) {
      this.stopFadeSmall();

      this.announcementBar1.style.display = "none";
      if (this.animateBig) this.announcementBar2.style.display = "none";

      setTimeout(() => {
        this.announcementBar1.style.display = "flex";
      }, 75);

      setTimeout(() => {
        this.fadeBig();
      }, 150);
    } else {
      if (this.animateBig) this.announcementBar2.style.display = "none";
      this.fadeBig();
    }
    if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
  }

  handleSmallAnimation() {
    if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

    this.slides.forEach((slide, index) => {
      if (index !== 0) slide.style.display = "none";
    });

    setTimeout(() => {
      this.fadeSmall();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = "flex";
      });

      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }, 150);
  }
}

customElements.define("slider-announcement-bar", SliderAnnouncementBar);

class CommentSectionNew extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegate = new Delegate(this.element);
    this.isSmallScreen = window.innerWidth < 1025;
    this.initForm();
  }

  connectedCallback() {
    this.delegate.on(
      "click",
      '[data-action="toggle-form"]',
      this.toggleForm.bind(this)
    );

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  initForm() {
    this.form = this.element.querySelector(".form-comment");
    this.formHeight = this.form.scrollHeight;
    if (this.isSmallScreen) {
      this.form.style.height = "0";
    }
    this.form.style.overflow = "hidden";
    this.form.style.transition = "height 0.3s ease, opacity 0.3s ease";
  }

  handleResize() {
    this.isSmallScreen = window.innerWidth < 1025;

    if (!this.isSmallScreen) {
      this.form.style.height = "auto";
      this.form.style.opacity = "1";
      this.form.style.overflow = "";
    } else if (
      this.form.getAttribute("aria-expanded") === "true" &&
      this.form.style.height === "auto"
    ) {
      this.form.style.height = `${this.form.scrollHeight}px`;
    }
  }

  toggleForm(event) {
    const target = event.target;
    if (!target) return;

    if (!this.isSmallScreen) {
      const isExpanded = target.getAttribute("aria-expanded") === "true";
      target.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      this.form.style.opacity = isExpanded ? "0" : "1";
      return;
    }

    target.getAttribute("aria-expanded") === "true"
      ? this.closeForm(target)
      : this.openForm(target);
  }

  openForm(target) {
    target.setAttribute("aria-expanded", "true");
    this.form.style.height = `${this.form.scrollHeight}px`;
    this.form.style.opacity = "1";

    this.form.addEventListener(
      "transitionend",
      () => {
        if (this.form.style.height !== "0px") {
          this.form.style.height = "auto";
        }
      },
      { once: true }
    );
  }

  closeForm(target) {
    target.setAttribute("aria-expanded", "false");

    if (this.isSmallScreen) {
      this.form.style.height = `${this.form.scrollHeight}px`;

      window.requestAnimationFrame(() => {
        this.form.style.height = "0";
        this.form.style.opacity = "0";
      });
    }

    this.initializeDefaultBlock();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "mouseover",
      '[data-action="show-on-hover"]',
      this.showContent.bind(this)
    );

    this.delegateElement.on(
      "mouseout",
      '[data-action="show-on-hover"]',
      this.hideContent.bind(this)
    );
  }

  showContent(event) {
    const target = event.target.closest('[data-action="show-on-hover"]');
    if (!target) return;

    const targetId = target.getAttribute("data-id");
    const blocks = this.element.querySelectorAll(".usp-block__content");


    blocks.forEach((block) => {
      const blockId = block.getAttribute("data-id");
      block.setAttribute("aria-hidden", blockId === targetId ? "false" : "true");
    });

  }

  initializeDefaultBlock() {
    const blocks = this.element.querySelectorAll(".usp-block__content");

    blocks.forEach((block, index) => {
      if (index === 0) {
        block.setAttribute("aria-hidden", "false");
      } else {
        block.setAttribute("aria-hidden", "true");
      }
    });
  }

  hideContent(event) {
    const blocks = this.element.querySelectorAll(".usp-block__content");

    blocks.forEach((block, index) => {
      block.setAttribute("aria-hidden", index === 0 ? "false" : "true");
    });
  }
}

customElements.define("comment-section-new", CommentSectionNew);

class ArticleSwipeNavigation extends HTMLElement {
  constructor() {
    super();
    this.touchstartX = 0;
    this.touchendX = 0;
    this.threshold = 100;

    this.checkDirection = this.checkDirection.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }

  connectedCallback() {
    this.addEventListener("touchstart", this.handleTouchStart);
    this.addEventListener("touchend", this.handleTouchEnd);
  }

  disconnectedCallback() {
    this.removeEventListener("touchstart", this.handleTouchStart);
    this.removeEventListener("touchend", this.handleTouchEnd);
  }

  handleTouchStart(event) {
    this.touchstartX = event.changedTouches[0].clientX;
    this.touchstartY = event.changedTouches[0].clientY;
  }

  handleTouchEnd(event) {
    this.touchendX = event.changedTouches[0].clientX;
    this.touchendY = event.changedTouches[0].clientY;

    this.checkDirection();
  }

  checkDirection() {
    const deltaX = this.touchendX - this.touchstartX;
    const deltaY = this.touchendY - this.touchstartY;


    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Horizontal swipe
      if (Math.abs(deltaX) >= this.threshold) {
        if (deltaX < 0) {
          const nextButton = document.querySelector(".main-article__next-article");
          if (nextButton) {
            nextButton.click();
          }
        } else {
          const prevButton = document.querySelector(
            ".main-article__previous-article"
          );
          if (prevButton) {
            prevButton.click();
          }
        }
      }
    }
  }
}

customElements.define("article-swipe-navigation", ArticleSwipeNavigation);



class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    if (this.element.querySelector('.swiper-wrapper-animation')) {
      window.addEventListener('DOMContentLoaded', () => this.bindEvents());
    }
  }

  bindEvents() {
    this.onMouseEnterBinder = this.onMouseEnter.bind(this);
    this.onMouseLeaveBinder = this.onMouseLeave.bind(this);

    this.delegateElement.on('mouseenter', '[data-action="hover"]', this.onMouseEnterBinder, true)
    this.delegateElement.on('mouseleave', '[data-action="hover"]', this.onMouseLeaveBinder, true)
    this.carouselElement.swiper.on('touchEnd', this.onUserInteraction.bind(this));
  }

  onUserInteraction() {
    this.carouselElement.swiper.params.speed = 300;
    this.carouselElement.querySelector('.swiper-wrapper').classList.remove('quote__wrapper-animation-disable');;
    this.carouselElement.querySelector('.swiper-wrapper-animation').classList.remove('swiper-wrapper-animation');
    this.carouselElement.swiper.update();

    this.carouselElement.swiper.off('touchEnd');
    this.delegateElement.off('mouseenter', '[data-action="hover"]', this.onMouseEnterBinder, true);
    this.delegateElement.off('mouseleave', '[data-action="hover"]', this.onMouseLeaveBinder, true);
  }

  onMouseEnter() {
    this.real = this.carouselElement.swiper.getTranslate()
    this.carouselElement.querySelector('.swiper-wrapper').style.transform = 'translate3d(' + (this.real) + 'px, 0, 0)';
    this.carouselElement.querySelector('.swiper-wrapper').classList.add('quote__wrapper-animation-disable');;
    this.carouselElement.swiper.autoplay.pause();
  }

  onMouseLeave() {
    this.carouselElement.querySelector('.swiper-wrapper').classList.remove('quote__wrapper-animation-disable');;
    this.carouselElement.swiper.update();
    this.carouselElement.swiper.autoplay.resume();
  }
}

customElements.define("quote-slider", QuoteSlider);

class lowestPrice extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.formatPriceAndAppend();
  }

  formatPriceAndAppend() {
    const price = this.getAttribute("data-price");
    const convertedPrice = parseInt(price) * Shopify.currency.rate;
    const priceElement = document.createElement("span");
    priceElement.textContent = Shopify.formatMoney(
      convertedPrice,
      window.theme.moneyFormat
    );
    this.element.innerHTML = priceElement.innerHTML;
  }
}
customElements.define("lowest-price", lowestPrice);



class UspsSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.isMobile = new Responsive().matchesBreakpoint("pocket");

    if (this.isMobile) {
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  connectedCallback() {
    // Immediate play attempt for videos already in the viewport
    this._playAllVideos();

    // Observe each video individually — plays it the moment it slides into view.
    // This is necessary because Swiper positions off-screen slides with CSS transforms
    // rather than display:none, so browsers won't autoplay them until they're visible.
    this._videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.play().catch(() => {});
        });
      },
      { threshold: 0.1 }
    );
    this.element.querySelectorAll("video").forEach((v) => this._videoObserver.observe(v));

    if (this.isMobile) {
      // Add slide change listener for mobile
      this.carouselElement.addEventListener(
        "swiper:slide-changed",
        this.onSlideChanged.bind(this)
      );
    } else {
      // Add hover listeners for desktop
      this.delegateElement.on(
        "mouseover",
        '[data-action="show-on-hover"]',
        this.showContent.bind(this)
      );
    }
  }

  disconnectedCallback() {
    if (this._videoObserver) this._videoObserver.disconnect();
  }

  _playAllVideos() {
    this.element.querySelectorAll("video").forEach((v) => v.play().catch(() => {}));
  }

  onSlideChanged(event) {
    const currentIndex = event.detail.currentIndex;
    const slide = this.carousel.swiperElement.slides[currentIndex];
    if (slide) {
      slide.querySelectorAll("video").forEach((v) => v.play().catch(() => {}));
    }
    const elementId = slide?.dataset.id;

    if (elementId) {
      this.updateContentVisibility(elementId);
    }
  }

  showContent(event) {
    const target = event.target.closest('[data-action="show-on-hover"]');
    if (!target) return;

    const targetId = target.getAttribute("data-id");
    if (targetId) {
      this.updateContentVisibility(targetId);
    }
  }

  updateContentVisibility(targetId) {
    const blocks = this.element.querySelectorAll(".usp-block__content");

    blocks.forEach((block) => {
      const blockId = block.getAttribute("data-id");
      block.setAttribute("aria-hidden", blockId === targetId ? "false" : "true");
    });
  }
}

customElements.define("usps-slider", UspsSlider);

class RevolutionSelectboxV2 {
  constructor(element, bodyScrollable, absolutePositioning, parentIdentifier, identifier) {
    if (!element) return;
    this.element = element;

    this.bodyScrollable = bodyScrollable;
    this.absolutePositioning = absolutePositioning;
    this.identifier = identifier;

    this.isOpen = false;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.selectedValueSpan = this.element.querySelector(".option-selector__selected-option");
    this.dropdown = this.element.querySelector(".option-selector__content-dropdown");
    if (!this.dropdown) return;
    this.button = this.element.querySelector(".option-selector__button");
    this.selectorParent = this.element.closest(`${parentIdentifier}`);

    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideBinder = this.onClickOutside.bind(this);

    this.delegateElement.on("click", '[data-action="toggle-selectbox"]', this.toggleDropdown.bind(this));
    this.delegateElement.on("click", '[data-action="handle-select"]', this.handleSelect.bind(this));
    this.delegateBody.on("selectbox:close", this.closeDropdown.bind(this));
  }

  onClickOutside(e) {
    const withinBoundaries = e.composedPath().includes(this.element);
    if (!withinBoundaries) {
      this.closeDropdown(e);
    }
  }

  handleSelect(e, target) {
    e.preventDefault();

    this.selectedValueSpan.innerHTML = target.dataset.value;
    this.dropdown.querySelector('.option-selector__option[selected="true"]').removeAttribute("selected");
    target.setAttribute("selected", "true");

    this.element.dispatchEvent(
      new CustomEvent("selectbox:change", {
        detail: {
          selectedValue: this.selectedValueSpan?.innerHTML || null,
          identifier: this.identifier || null,
        },
        bubbles: true
      })
    );

    this.closeDropdown();
  }

  initSelectbox() {
    const selectedValue = this.dropdown.querySelector('[selected="true"]');
    if (selectedValue) {
      this.selectedValueSpan.innerHTML = selectedValue.dataset.value;
    }

    if (this.absolutePositioning) {
      this.dropdown.classList.add('absolute');
    }

    this.animationOptions = {
      duration: 500,
      fill: "none",
      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
    };
  }

  toggleDropdown(e) {
    e.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(e);
    } else {
      this.openDropdown(e);
    }
  }

  checkElementBottomDistance() {
    const distanceToBottom = window.innerHeight - this.button.getBoundingClientRect().bottom - 24;

    if (distanceToBottom < this.dropdown.offsetHeight) {
      this.dropdown.classList.remove('from-top');
      this.dropdown.classList.add('from-bottom');
    } else {
      this.dropdown.classList.remove('from-bottom');
      this.dropdown.classList.add('from-top');
    }
  }

  setAnimationSettings() {
    const originalStyles = {
      position: this.dropdown.style.position,
      visibility: this.dropdown.style.visibility,
      display: this.dropdown.style.display,
      pointerEvents: this.dropdown.style.pointerEvents,
      height: this.dropdown.style.height,
    };

    this.dropdown.style.position = "absolute";
    this.dropdown.style.visibility = "hidden";
    this.dropdown.style.display = "flex";
    this.dropdown.style.pointerEvents = "none";
    this.dropdown.style.height = "auto";

    const dropdownHeight = this.dropdown.offsetHeight;

    Object.keys(originalStyles).forEach((key) => {
      this.dropdown.style[key] = originalStyles[key];
    });

    this.expand = [
      { height: "0" },
      { height: dropdownHeight + "px" },
    ];

    this.retract = [
      { height: dropdownHeight + "px" },
      { height: "0" },
    ];
  }


  openDropdown(e) {
    e.preventDefault();

    if (this.isOpen) return;

    this.button.style.width = 'fit-content';
    this.button.style.width = this.button.getBoundingClientRect().width + 'px'

    this.element.dispatchEvent(new CustomEvent('selectbox:close', { detail: this.bodyScrollable, bubbles: true }));

    this.delegateBody.on("click", "body", this.onClickOutsideBinder);
    if (this.bodyScrollable) this.onScroll = scrollListener.addScrollListener(this, this.closeDropdown.bind(this));

    this.dropdown.setAttribute("aria-hidden", false);

    if (this.absolutePositioning) {
      this.checkElementBottomDistance();
    } else {
      this.setAnimationSettings();
    }

    requestAnimationFrame(() => {
      this.dropdown.setAttribute("aria-expanded", true)

      this.dropdown.style.width = this.button.getBoundingClientRect().width + 'px';
      if (!this.absolutePositioning) {
        this.animation = this.dropdown.animate(this.expand, this.animationOptions);
      }

      // If the body shouldn't be scrollable, disable body scroll
      if (!this.bodyScrollable) {
        const focus = this.element.querySelector('[data-scrollable]');
        bodyScrollLock.clearAllBodyScrollLocks();
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }
    });

    // If there are multiple dropdowns on the same level, 
    if (this.selectorParent) {
      this.selectorParent.style.zIndex = '10';
    }

    if (this.selectorParent) {
      if (!this.absolutePositioning) {
        this.animation?.finished.then(() => {
          this.selectorParent.style.zIndex = '';
        });

        this.animation = null;
      } else {
        this.element.addEventListener("animationend", () => {
          this.selectorParent.style.zIndex = '';
        }, { once: true });
      }
    }

    trapFocus(this.dropdown);
    this.isOpen = true;
  }

  closeDropdown() {
    if (!this.isOpen) return;

    this.delegateBody.off("click", "body", this.onClickOutsideBinder);
    if (this.bodyScrollable) this.onScroll?.removeScrollListener() && (this.onScroll = null);

    this.button.style.width = 'fit-content';
    this.button.style.width = this.button.getBoundingClientRect().width + 'px';
    this.dropdown.style.width = this.button.getBoundingClientRect().width + 'px';

    if (this.selectorParent) {
      this.selectorParent.style.zIndex = '';
    }

    this.dropdown.setAttribute("aria-expanded", false)

    if (!this.absolutePositioning) {
      const animation = this.dropdown.animate(this.retract, this.animationOptions);

      animation.finished.then(() => {
        this.dropdown.setAttribute("aria-hidden", true);
        this.isOpen = false;
      });
    } else {
      this.element.addEventListener("animationend", () => {
        this.dropdown.setAttribute("aria-hidden", true);
        this.isOpen = false;
      }, { once: true });
    }

    if (!this.bodyScrollable) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    removeTrapFocus(this.mainDropdownContent);
  }
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.discountSpan = this.element.querySelector('.subscription-options__discount');
    this.subscription = this.discountSpan ? true : false;
    this.variants = this.element.hasAttribute('data-has-variants');
    if (!this.subscription && !this.variants) return;

    const variantSelectbox = this.element.querySelectorAll('.product-card__variant-options .option-selector');
    this.subscriptionSelectbox = this.element.querySelector('.product-card__subscription-options .option-selector');

    this.delegateElement = new Delegate(this.element);
    variantSelectbox.forEach(selector => new RevolutionSelectboxV2(selector, true, true, '.option-selector__wrapper', "variants"));
    new RevolutionSelectboxV2(this.subscriptionSelectbox, true, true, null, "subscriptions");

    this.sellingPlanInput = this.element.querySelector('.product-card__form input[name="selling_plan"');
    this.variantInput = this.element.querySelector('.product-card__form input[name="id"');
    if (this.variants) this.variantData = JSON.parse(this.element.querySelector('[type="application/json"]').textContent);
    this.currentVariant = this.variantInput.value;

    this.prices = this.element.querySelector('.product-card__price');
    this.updateVariant();
    this.bindEvents();
  }

  bindEvents() {
    if (this.subscription) this.delegateElement.on("click", '[data-action="select-subscription"]', this.subscribeOrNot.bind(this));
    this.delegateElement.on("selectbox:change", (e) => e.detail.identifier === "variants" ? this.updateVariant() : this.updateSubscription());
    this.delegateElement.on("mouseleave", this.closeSelectbox.bind(this), true);
  }

  closeSelectbox(e) {
    if (e.target !== this.element) return;
    this.element.dispatchEvent(new CustomEvent("selectbox:close", { bubbles: true }));
  }

  updateVariant() {
    if (!this.variants) return;

    this.updateOptions();
    this.updateMasterId();
    this.updatePrice();
  }

  updatePrice() {

    if (this.prices && this.currentVariant) {
      const newOrgPrice = Shopify.formatMoney(
        this.currentVariant.price,
        window.theme.moneyFormat
      );
      const newCompareAtPrice = Shopify.formatMoney(
        this.currentVariant.compare_at_price,
        window.theme.moneyFormat
      );

      let flexVertical = this.prices.querySelector('.flex-vertical');
      let orgPrice = this.prices.querySelector('.product-card__price-item');
      let compareAtPrice = this.prices.querySelector('.product-card__compare-at-price-to-update');

      if (compareAtPrice && newCompareAtPrice && this.currentVariant.compare_at_price > this.currentVariant.price) {
        compareAtPrice.innerText = newCompareAtPrice;
      } else if (!compareAtPrice && newCompareAtPrice && this.currentVariant.compare_at_price > this.currentVariant.price) {
        let newElement = document.createElement('div');
        newElement.className = 'product-card__compare-at-price-to-update product-card__price-compare u-p2';
        newElement.textContent = newCompareAtPrice;
        if (flexVertical) {
          flexVertical.insertBefore(newElement, flexVertical.firstChild);
        } else return;
      }

      orgPrice.innerText = newOrgPrice;
    }
  }

  updateMasterId() {
    const options = this.updateOptions();

    this.currentVariant = this.variantData.find((variant) => {
      return options.every((option) => {
        return variant.options.includes(option);
      });
    });

    if (this.currentVariant)
      this.variantInput.value = this.currentVariant.id;
  }

  updateOptions() {
    return Array.from(this.element.querySelectorAll('.product-card__variant-options .option-selector__selected-option')).map(option => option.textContent.trim());
  }

  subscribeOrNot(e, target) {
    if (target.hasAttribute('data-default')) {
      this.sellingPlanInput.value = "";
    } else {
      this.updateSubscription(e);
    }
  }

  updateSubscription(e) {
    if (!this.subscription) return;

    const selectedPlan = this.subscriptionSelectbox.querySelector('.option-selector__option[selected="true"]');
    if (selectedPlan) {
      this.sellingPlanInput.value = selectedPlan.dataset.plan;
      this.discountSpan.innerHTML = selectedPlan.dataset.discount;

      if (e && !e.composedPath().some(el => el.classList && el.classList.contains('option-selector__button'))) {
        selectedPlan.closest('label').previousElementSibling.click();
      }
    }
  }
}
customElements.define("product-card", ProductCard);

class ProductCardDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.drawer = new Drawer(this.element, {
      onOpen: (e) => {
        this.wipeContent();
        this.renderContent(e);
      }
    });

    this.drawerContent = this.element.querySelector('.Drawer--Content');
    new AddToCart(this.element);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="select-subscription"]', this.subscribeOrNot.bind(this));
    this.delegateElement.on("selectbox:change", (e) => e.detail.identifier === "variants" ? this.updateVariant() : this.updateSubscription());
  }

  updateVariant() {
    if (!this.variants) return;

    this.updateOptions();
    this.updateMasterId();
  }

  updateMasterId() {
    const options = this.updateOptions();
    if (this.variants) this.variantData = JSON.parse(this.element.querySelector('[type="application/json"]').textContent);

    this.currentVariant = this.variantData.find((variant) => {
      return options.every((option) => {
        return variant.options.includes(option);
      });
    });

    this.variantInput.value = this.currentVariant.id;
  }

  updateOptions() {
    return Array.from(this.element.querySelectorAll('.product-card__variant-options .option-selector__selected-option')).map(option => option.textContent.trim());
  }

  subscribeOrNot(e, target) {
    if (target.hasAttribute('data-default')) {
      this.sellingPlanInput.value = "";
    } else {
      this.updateSubscription(e);
    }
  }

  updateSubscription(e) {
    if (!this.subscription) return;

    const selectedPlan = this.subscriptionSelectbox.querySelector('.option-selector__option[selected="true"]');
    if (selectedPlan) {
      this.sellingPlanInput.value = selectedPlan.dataset.plan;
      this.discountSpan.innerHTML = selectedPlan.dataset.discount;
      if (e && !e.composedPath().some(el => el.classList && el.classList.contains('option-selector__button'))) {
        selectedPlan.closest('label').previousElementSibling.click();
      }
    }
  }

  renderContent(e) {
    const contentToRender = e.target.closest('.product-card').querySelector('.product-card__purchase-options');
    const clone = contentToRender.cloneNode(true);

    this.updateAttributes(clone);
    this.drawerContent.appendChild(clone);

    this.discountSpan = this.element.querySelector('.subscription-options__discount');
    this.subscription = this.discountSpan ? true : false;
    this.variants = this.element.querySelector('.product-card__variant-options');

    this.sellingPlanInput = this.element.querySelector('.product-card__form input[name="selling_plan"');
    this.variantInput = this.element.querySelector('.product-card__form input[name="id"');
    if (this.variants) this.variantData = JSON.parse(this.element.querySelector('[type="application/json"]').textContent);
    this.currentVariant = this.variantInput.value;

    const variantSelectbox = this.element.querySelectorAll('.product-card__variant-options .option-selector');
    this.subscriptionSelectbox = this.element.querySelector('.product-card__subscription-options .option-selector');

    variantSelectbox.forEach(selector => new RevolutionSelectboxV2(selector, true, true, '.option-selector__wrapper', "variants"));
    new RevolutionSelectboxV2(this.subscriptionSelectbox, true, true, null, "subscriptions");
  }

  updateAttributes(clone) {
    clone.querySelectorAll('[id]').forEach(child => {
      child.setAttribute('id', child.getAttribute('id') + '--mobile');
    });


    clone.querySelectorAll('[for]').forEach(child => {
      child.setAttribute('for', child.getAttribute('for') + '--mobile');
    });
  }

  wipeContent() {
    this.drawerContent.innerHTML = '';
  }
}
customElements.define("product-card-drawer", ProductCardDrawer);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateBody = new Delegate(document.body);
    new RevolutionSwiper(this.querySelector(".product-recommendations__swiper"));
    new AddToCart(this.element)
  }

  connectedCallback() {
    this.delegateBody.on('recommendations:reload', this.reloadRecommendations.bind(this));
    this.loadRecommendations(this.dataset.url);

  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = new DOMParser().parseFromString(text, "text/html")

      const newSwiper = html.querySelector(".product-recommendations__swiper");
      const oldSwiper = this.element.querySelector(".product-recommendations__swiper");
      oldSwiper.swiper.destroy();

      if (newSwiper) {
        oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);
        new RevolutionSwiper(newSwiper);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class ProductZoom extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element;
    if (responsive.matchesBreakpoint("lap_and_up")) {
      new RevolutionSwiper(this.swiperElement);
    }

    this.largestSlideIndex = this.swiperElement.swiper.slides.length - 1;
    this.lastIndex = 0;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="slide-to"]', this.selectSlide.bind(this));
    this.swiperElement.swiper.on('slideChange', this.onSlideChange.bind(this));
  }

  show(index) {
    this.element.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() =>
      requestAnimationFrame(() => this.element.setAttribute('data-animate', 'true')
      ));

    this.setActiveSlide(index);
  }

  hide() {
    this.element.setAttribute('data-animate', 'false');

    const transitionEndHandler = (e) => {
      if (e.propertyName === "opacity") {
        this.element.setAttribute('aria-hidden', 'true');
        this.element.removeEventListener("transitionend", transitionEndHandler);
      }
    };

    this.element.addEventListener("transitionend", transitionEndHandler);
  }

  setActiveSlide(index) {
    const currentlyActive = this.element.querySelector('.product__zoom-slide--active');
    if (currentlyActive) currentlyActive.classList.remove('product__zoom-slide--active');
    const newActive = this.element.querySelector(`.product__zoom-slide[data-swiper-slide-index="${index}"]`);
    newActive.classList.add("product__zoom-slide--active");

    if (!newActive.classList.contains("swiper-slide-visible") && currentlyActive) {
      this.disable = true;
      this.swiperElement.swiper.slideTo(index);
      setTimeout(() => {
        this.disable = false;
      }, 250);
    }
  }

  selectSlide(e, target) {
    const currentlyActive = this.element.querySelector('.product__zoom-slide--active');
    if (currentlyActive) currentlyActive.classList.remove('product__zoom-slide--active');
    target.classList.add('product__zoom-slide--active')

    const goToIndex = parseInt(target.dataset.index);
    this.element.dispatchEvent(new CustomEvent('slide:change', { bubbles: true, detail: goToIndex }));
  }

  getSwipeDirection(currentIndex, lastIndex) {
    let isNext = false;
    let isPrev = false;

    if (lastIndex === this.largestSlideIndex && currentIndex === 0) {
      isNext = true;
    } else if (lastIndex === 0 && currentIndex === this.largestSlideIndex) {
      isPrev = true;
    } else {
      if (currentIndex > lastIndex) {
        isNext = true;
      } else if (currentIndex < lastIndex) {
        isPrev = true;
      }
    }

    return { isNext, isPrev };
  }

  onSlideChange() {
    if (this.disable) return;

    const currentlyActive = this.element.querySelector('.product__zoom-slide--active');
    const currentlyActiveIndex = parseInt(currentlyActive.dataset.swiperSlideIndex);

    const { isNext, isPrev } = this.getSwipeDirection(this.swiperElement.swiper.realIndex, this.lastIndex);

    if (isPrev) {
      let prevIndex = currentlyActiveIndex - 1;
      if (currentlyActiveIndex == 0) {
        prevIndex = this.largestSlideIndex;
      }

      this.element.querySelector(`.swiper-slide[data-index="${prevIndex}"]`).classList.add('product__zoom-slide--active');
    } else if (isNext) {
      let nextIndex = currentlyActiveIndex + 1;
      if (currentlyActiveIndex == this.largestSlideIndex) {
        nextIndex = 0;
      }

      this.element.querySelector(`.swiper-slide[data-index="${nextIndex}"]`).classList.add('product__zoom-slide--active');
    }

    if (this.swiperElement.swiper.realIndex !== this.lastIndex) {
      currentlyActive.classList.remove('product__zoom-slide--active');
    }

    const goToIndex = parseInt(this.element.querySelector('.product__zoom-slide--active').dataset.index);
    this.element.dispatchEvent(new CustomEvent('slide:change', { bubbles: true, detail: goToIndex }));

    this.lastIndex = this.swiperElement.swiper.realIndex;
  }
}
customElements.define("product-zoom", ProductZoom);